import type { PromptTemplateSummary } from '../types';

export const FA_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  '8-bit-orbit-video-template': {
    description:
      'قالب ویدیویی مبتنی بر HyperFrames برای طراحی حرکتی دک پیکسلی رترو.\nهنگامی استفاده کنید که کاربران یک ترکیب HTML-به-ویدیوی چندصحنه‌ای و با وفاداری بالا\nهمراه با ترنزیشن‌های پیشرفته، کنترل‌های پیش‌نمایش تعاملی و سبک پیش‌فرض\nآماده‌ی رندر می‌خواهند.',
    examplePrompt:
      'یک دک ویدیویی سه‌صفحه‌ای HyperFrames با سبک رترو ۸ بیتی بساز، با ترنزیشن‌های پیشرفته، حرکت غنی و هر صفحه زیر ۳ ثانیه.',
  },
  'ad-creative': {
    description:
      'خلاقیت تبلیغاتی شامل تیترها، توضیحات و متن اصلی را تولید و بازنگری کن. برای بازنگری تبلیغات شبکه‌های اجتماعی پولی و جست‌وجو مفید است.',
    examplePrompt:
      'خلاقیت تبلیغاتی شامل تیترها، توضیحات و متن اصلی را تولید و بازنگری کن.',
  },
  'after-hours-editorial-template': {
    description:
      'قالب لاکچری تیره و ادیتوریال HyperFrames برای استوری‌بوردهای سینمایی سه‌صفحه‌ای،\nالهام‌گرفته از کارت‌های عنوان اوت‌کوتور و صفحات فصل‌بندی مجلات. هنگامی استفاده کنید که\nکاربر صفحات حرکتی به سبک مد لوکس، روایت‌گری با حال‌وهوای تیره و فونت سریف،\nیا زیبایی‌شناسی ارائه‌ی تیره و سطح‌بالا با ترنزیشن‌های غنی می‌خواهد.',
    examplePrompt:
      'یک سکانس ادیتوریال سه‌صفحه‌ای HyperFrames با سبک تیره‌ی اوت‌کوتور بساز: تایپوگرافی لوکس با فونت سریف، رنگ تأکیدی سرخابی، ترنزیشن‌های شیک فصل‌بندی و دانه‌بندی سینمایی. هر صفحه را زیر ۳ ثانیه نگه دار.',
  },
  'agent-browser': {
    description:
      'CLI خودکارسازی مرورگر برای عامل‌های هوش مصنوعی. هنگامی استفاده کنید که کاربر نیاز به بازرسی،\nتست یا خودکارسازی رفتار مرورگر دارد: پیمایش صفحات، پر کردن فرم‌ها،\nکلیک روی دکمه‌ها، گرفتن اسکرین‌شات، استخراج داده‌های صفحه، خواندن زمینه‌ی\nتب مرورگر انتخاب‌شده‌ی Open Design، تست وب‌اپ‌ها، داگ‌فودینگ پیش‌نمایش‌های\nOpen Design، QA، شکار باگ یا بازبینی کیفیت اپ. مگر اینکه کاربر صراحتاً مرور خارجی\nبخواهد، URLهای پیش‌نمایش محلی Open Design را ترجیح بده.',
    examplePrompt:
      'CLI خودکارسازی مرورگر برای عامل‌های هوش مصنوعی.',
  },
  'ai-music-album': {
    description:
      'تولید آلبوم موسیقی هوش مصنوعی در چرخه‌ی کامل عمر — ایده‌پردازی، نگارش متن ترانه، توالی‌بندی قطعات و خروجی‌گیری. برای تجربه‌های آلبوم مستقل و موسیقی متن برند مفید است.',
    examplePrompt:
      'تولید آلبوم موسیقی هوش مصنوعی در چرخه‌ی کامل عمر — ایده‌پردازی، نگارش متن ترانه، توالی‌بندی قطعات و خروجی‌گیری.',
  },
  'algorithmic-art': {
    description:
      'با استفاده از p5.js و تصادفی‌بودن مبتنی بر دانه (seed) هنر مولد بساز تا هر رندر بازتولیدپذیر باشد. برای پوسترهای رویه‌ای، تصاویر ثابت به سبک حرکتی و مطالعات هنری فریم مفید است.',
    examplePrompt:
      'با استفاده از p5.js و تصادفی‌بودن مبتنی بر دانه (seed) هنر مولد بساز تا هر رندر بازتولیدپذیر باشد.',
  },
  'apple-hig': {
    description:
      'رهنمودهای رابط انسانی Apple در قالب ۱۴ مهارت عاملی که پلتفرم‌ها، مبانی، اجزا، الگوها، ورودی‌ها و فناوری‌ها را برای iOS، macOS، visionOS، watchOS و tvOS پوشش می‌دهد.',
    examplePrompt:
      'رهنمودهای رابط انسانی Apple در قالب ۱۴ مهارت عاملی که پلتفرم‌ها، مبانی، اجزا، الگوها، ورودی‌ها و فناوری‌ها را برای iOS، macOS، visionOS، watchOS و tvOS پوشش می‌دهد.',
  },
  'article-magazine': {
    description:
      'چیدمان مقاله‌ی مجله‌ای الهام‌گرفته از Huashu / huashu-md-html برای تبدیل Markdown یا یادداشت‌ها به یک مقاله‌ی بلندِ HTML پرداخته‌شده.',
    examplePrompt:
      'از قالب Magazine Article استفاده کن تا محتوای مرا به یک مقاله‌ی بلندِ HTML الهام‌گرفته از Huashu / huashu-md-html تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'artifacts-builder': {
    description:
      'مجموعه‌ای از ابزارها برای ساخت آرتیفکت‌های HTML پیچیده و چنداجزایی claude.ai با استفاده از فناوری‌های مدرن وب فرانت‌اند (React، Tailwind CSS، shadcn/ui).',
    examplePrompt:
      'مجموعه‌ای از ابزارها برای ساخت آرتیفکت‌های HTML پیچیده و چنداجزایی claude.ai با استفاده از فناوری‌های مدرن وب فرانت‌اند (React، Tailwind CSS، shadcn/ui).',
  },
  'brainstorming': {
    description:
      'ایده‌های خام را از طریق پرسش‌گری ساختارمند و کاوش گزینه‌های جایگزین به طرح‌های کاملاً شکل‌گرفته تبدیل کن. در مراحل اولیه‌ی کار مفهومی مفید است.',
    examplePrompt:
      'ایده‌های خام را از طریق پرسش‌گری ساختارمند و کاوش گزینه‌های جایگزین به طرح‌های کاملاً شکل‌گرفته تبدیل کن.',
  },
  'brand-guidelines': {
    description:
      'رنگ‌ها و تایپوگرافی رسمی برند Anthropic را برای هویت بصری یکدست و استانداردهای طراحی حرفه‌ای روی آرتیفکت‌ها اعمال کن. مرجعی برای شکل‌دهی به نمونه‌ی خودت.',
    examplePrompt:
      'رنگ‌ها و تایپوگرافی رسمی برند Anthropic را برای هویت بصری یکدست و استانداردهای طراحی حرفه‌ای روی آرتیفکت‌ها اعمال کن.',
  },
  'brandkit': {
    description:
      'مهارت تولید تصویر کیت برند لوکس برای ساخت بوردهای رهنمود برند سطح‌بالا، سیستم‌های لوگو، دک‌های هویتی و ارائه‌های جهان بصری. آموزش‌دیده برای سیستم‌های برند مینیمال، سینمایی، ادیتوریال، دارک-تک، لوکس، فرهنگی، امنیتی، گیمینگ، ابزار توسعه‌دهنده و اپ‌های مصرفی. بهینه‌شده برای مفهوم‌پردازی هدفمند لوگو، ترکیب‌بندی پالوده، تایپوگرافی کم‌تراکم، معنای نمادین قوی، ماک‌آپ‌های لوکس، تصاویر با هدایت هنری و چیدمان‌های گرید انعطاف‌پذیر.',
    examplePrompt:
      'یک تصویر مرور کیت برند لوکس برای این محصول بساز: جهت‌گیری لوگو، پالت، تایپوگرافی، کاربردها و یک جهان بصری منسجم.',
  },
  'industrial-brutalist-ui': {
    description:
      'رابط‌های مکانیکی خام که چاپ تایپوگرافیک سوئیسی را با زیبایی‌شناسی ترمینال نظامی درهم می‌آمیزند. گریدهای سفت‌وسخت، کنتراست افراطی در مقیاس تایپ، رنگ کاربردی، افکت‌های فرسایش آنالوگ. برای داشبوردهای پرداده، نمونه‌کارها یا سایت‌های ادیتوریال که باید مانند نقشه‌های از طبقه‌بندی‌خارج‌شده به نظر برسند.',
    examplePrompt:
      'یک رابط صنعتی-بروتالیست بساز با گریدهای سفت‌وسخت، موتیف‌های تله‌متری تاکتیکی، تایپوگرافی قوی و دقت مکانیکی.',
  },
  'canvas-design': {
    description:
      'با استفاده از فلسفه‌ی طراحی و اصول زیبایی‌شناسی، هنر بصری زیبا در اسناد PNG و PDF برای پوسترها، تصویرسازی‌ها و آثار ثابت بساز.',
    examplePrompt:
      'با استفاده از فلسفه‌ی طراحی و اصول زیبایی‌شناسی، هنر بصری زیبا در اسناد PNG و PDF برای پوسترها، تصویرسازی‌ها و آثار ثابت بساز.',
  },
  'card-twitter': {
    description:
      'کارت نقل‌قول یا داده‌ی Twitter که برای همراهی با یک پست طراحی شده است.',
    examplePrompt:
      'از قالب Twitter Share Card استفاده کن تا محتوای مرا به یک کارت نقل‌قول یا داده‌ی Twitter که برای همراهی با یک پست طراحی شده تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'card-xiaohongshu': {
    description:
      'کارت‌های دانشی به سبک Xiaohongshu، چیده‌شده به‌صورت یک کاروسل چندکارتی قابل‌کشیدن.',
    examplePrompt:
      'از قالب Xiaohongshu Card استفاده کن تا محتوای مرا به یک کاروسل کارت‌های دانشی قابل‌کشیدن به سبک Xiaohongshu تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'color-expert': {
    description:
      'مهارت متخصص علم رنگ با ۲۸۶ هزار واژه منبع مرجع که OKLCH/OKLAB، تولید پالت، دسترس‌پذیری/کنتراست، نام‌گذاری رنگ، آمیختن رنگدانه و نظریه‌ی تاریخی رنگ را پوشش می‌دهد.',
    examplePrompt:
      'مهارت متخصص علم رنگ با ۲۸۶ هزار واژه منبع مرجع که OKLCH/OKLAB، تولید پالت، دسترس‌پذیری/کنتراست، نام‌گذاری رنگ، آمیختن رنگدانه و نظریه‌ی تاریخی رنگ را پوشش می‌دهد.',
  },
  'competitive-ads-extractor': {
    description:
      'تبلیغات رقبا را از کتابخانه‌های تبلیغاتی استخراج و تحلیل کن تا پیام‌رسانی و رویکردهای خلاقانه‌ای که اثرگذارند را درک کنی.',
    examplePrompt:
      'تبلیغات رقبا را از کتابخانه‌های تبلیغاتی استخراج و تحلیل کن تا پیام‌رسانی و رویکردهای خلاقانه‌ای که اثرگذارند را درک کنی.',
  },
  'copywriting': {
    description:
      'متن بازاریابی برای صفحات فرود، صفحات اصلی و تبلیغات را بنویس و بازنویسی کن. به‌عنوان شریک سرویراستار متن در طول لانچ‌ها مفید است.',
    examplePrompt:
      'متن بازاریابی برای صفحات فرود، صفحات اصلی و تبلیغات را بنویس و بازنویسی کن.',
  },
  'creative-director': {
    description:
      'کارگردان خلاق هوش مصنوعی با خودارزیابی بازگشتی: بیش از ۲۰ روش‌شناسی (SIT، TRIZ، Bisociation، SCAMPER، Synectics)، ارزیابی سه‌محوری کالیبره‌شده در برابر Cannes/D&AD/HumanKind، فرایند پنج‌مرحله‌ای از بریف تا ارائه.',
    examplePrompt:
      'کارگردان خلاق هوش مصنوعی با خودارزیابی بازگشتی: بیش از ۲۰ روش‌شناسی (SIT، TRIZ، Bisociation، SCAMPER، Synectics)، ارزیابی سه‌محوری کالیبره‌شده در برابر Cannes/D&AD/HumanKind، فرایند پنج‌مرحله‌ای از بریف تا ارائه.',
  },
  'd3-visualization': {
    description:
      'به ایجنت آموزش می‌دهد نمودارهای D3 و تجسم‌های تعاملی داده تولید کند. یک مهارت جامع D3.js با نمونه‌هایی در انواع نمودارها و تکنیک‌ها که دانشی در سطح متخصص به ایجنت می‌دهد تا تجسم‌های پیچیده و تعاملی بسازد. مناسب برای داشبوردهای تحریری، گزارش‌ها، نمونه‌های اولیه پرداده و گرافیک‌های توضیحی.',
    examplePrompt:
      'به ایجنت آموزش می‌دهد نمودارهای D3 و تجسم‌های تعاملی داده تولید کند.',
  },
  'data-report': {
    description:
      'داده‌های CSV، Excel یا JSON را به یک صفحه گزارش بصری شکیل تبدیل می‌کند.',
    examplePrompt:
      'از قالب Data Visualization Report برای تبدیل داده‌های CSV، Excel یا JSON من به یک صفحه گزارش بصری شکیل استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار بپرهیز.',
  },
  'deck-guizang-editorial': {
    description:
      'تلاقی مجله تحریری با جوهر الکترونیک: ۱۰ چیدمان و ۵ پالت (Ink، Indigo Porcelain، Forest Ink، Kraft Paper، Dune).',
    examplePrompt:
      'از قالب Guizang Editorial E-Ink Deck برای تبدیل محتوای من به یک اسلاید افقی تلاقی مجله تحریری × جوهر الکترونیک با ۱۰ چیدمان و ۵ پالت استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار بپرهیز.',
  },
  'deck-open-slide-canvas': {
    description:
      'اسلاید با بوم قفل‌شده ۱۹۲۰x۱۰۸۰ با ترکیب‌بندی آزاد در سطح کامپوننت React، بدون وابستگی به قالب ثابت.',
    examplePrompt:
      'از قالب Open-Slide 1920 Canvas Deck برای تبدیل محتوای من به یک اسلاید قفل‌شده ۱۹۲۰x۱۰۸۰ با ترکیب‌بندی آزاد و چیدمان در سطح کامپوننت React استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار بپرهیز.',
  },
  'deck-swiss-international': {
    description:
      'شبکه ۱۶ ستونی، یک رنگ تأکیدی اشباع‌شده و ۲۲ چیدمان قفل‌شده (Klein Blue، Lemon، Mint، Safety Orange).',
    examplePrompt:
      'از قالب Swiss International Deck برای تبدیل محتوای من به یک اسلاید با شبکه ۱۶ ستونی، یک رنگ تأکیدی اشباع‌شده و ۲۲ چیدمان قفل‌شده استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار بپرهیز.',
  },
  'design-brief': {
    description:
      'یک بریف طراحی ساختاریافته که با قالب پروتکل I-Lang نوشته شده را به یک مشخصات طراحی مشخص تجزیه می‌کند.\nبا الزام به ابعاد صریح، ابهام را از درخواست‌های مبهمی مانند\n«حرفه‌ای‌اش کن» حذف می‌کند: پالت، تایپوگرافی،\nچیدمان، حال‌وهوا، تراکم و محدودیت‌ها.\nکلیدواژه‌های فعال‌ساز: «design brief»، «create a design brief»، «ilang brief»، «structured brief».',
    examplePrompt:
      'یک بریف طراحی ساختاریافته که با قالب پروتکل I-Lang نوشته شده را به یک مشخصات طراحی مشخص تجزیه می‌کند.',
  },
  'design-consultation': {
    description:
      'یک سیستم طراحی کامل را از صفر با ریسک‌های خلاقانه و ماکاپ‌های واقع‌گرایانه محصول بساز. مناسب برای کارگاه‌های آغازین و کار برندسازی از صفر.',
    examplePrompt:
      'یک سیستم طراحی کامل را از صفر با ریسک‌های خلاقانه و ماکاپ‌های واقع‌گرایانه محصول بساز.',
  },
  'design-md': {
    description:
      'فایل‌های DESIGN.md را بساز و مدیریت کن. مناسب برای ثبت جهت‌گیری طراحی، توکن‌ها و قواعد بصری در یک منبع واحد حقیقت.',
    examplePrompt:
      'فایل‌های DESIGN.md را بساز و مدیریت کن.',
  },
  'design-review': {
    description:
      'طراحی که کد می‌زند: ممیزی بصری و سپس رفع اشکالات با کامیت‌های اتمی و اسکرین‌شات‌های قبل/بعد. مناسب برای بهبود رابط کاربری منتشرشده پیش از عرضه.',
    examplePrompt:
      'طراحی که کد می‌زند: ممیزی بصری و سپس رفع اشکالات با کامیت‌های اتمی و اسکرین‌شات‌های قبل/بعد.',
  },
  'digits-fintech-swiss-template': {
    description:
      'قالب اسلاید فین‌تک با شبکه سوئیسی در کنتراست مشکی / کاغذ گرم / لیموسبز نئونی.\nزمانی استفاده کن که کاربران اسلایدهای داده‌محور لوکس با چیدمان ماژولار سختگیرانه،\nکارت‌های عددی پررنگ، حرکت مهارشده و ناوبری با صفحه‌کلید/کلیک در یک فایل HTML بخواهند.',
    examplePrompt:
      'یک اسلاید استراتژی فین‌تک با شبکه سوئیسی همراه با کارت‌های داده ماژولار، رنگ تأکیدی لیموسبز و ناوبری تمیز با صفحه‌کلید بساز.',
  },
  'doc': {
    description:
      'اسناد .docx را با وفاداری به قالب‌بندی و چیدمان از طریق مهارت سند OpenAI بخوان، بساز و ویرایش کن.',
    examplePrompt:
      'اسناد .docx را با وفاداری به قالب‌بندی و چیدمان از طریق مهارت سند OpenAI بخوان، بساز و ویرایش کن.',
  },
  'doc-kami-parchment': {
    description:
      'بوم پوست‌کاغذی گرم (#f5f4ed)، رنگ تأکیدی تک‌رنگ آبی‌جوهری (#1B365D)، یک خانواده فونت سریف و تایپوگرافی در سطح تحریری.',
    examplePrompt:
      'از قالب Kami Parchment Document برای تبدیل محتوای من به یک سند پوست‌کاغذی گرم با رنگ‌های تأکیدی تک‌رنگ آبی‌جوهری، یک خانواده فونت سریف و تایپوگرافی در سطح تحریری استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار بپرهیز.',
  },
  'docx': {
    description:
      'اسناد Word را با تغییرات ردیابی‌شده، نظرات و قالب‌بندی بساز، ویرایش و تحلیل کن. مناسب برای بریف‌های طراحی، اسناد متنی و خروجی‌های آماده برای بازبینی.',
    examplePrompt:
      'اسناد Word را با تغییرات ردیابی‌شده، نظرات و قالب‌بندی بساز، ویرایش و تحلیل کن.',
  },
  'domain-name-brainstormer': {
    description:
      'ایده‌های خلاقانه نام دامنه تولید کن و در دسترس بودن آن‌ها را در چندین TLD از جمله .com، .io، .dev و .ai بررسی کن.',
    examplePrompt:
      'ایده‌های خلاقانه نام دامنه تولید کن و در دسترس بودن آن‌ها را در چندین TLD از جمله .com، .io، .dev و .ai بررسی کن.',
  },
  'ecommerce-image-workflow': {
    description:
      'گردش‌کار تصویر تجارت الکترونیک مبتنی بر محصول مرجع برای تولید مجموعه‌ای فشرده\nاز تصاویر اصلی، ویژگی و سبک‌زندگی وفادار به محصول از روی عکس‌های\nمرجع واقعی محصول. نسخه ۱ به آپلود تصاویر محصول نیاز دارد و عمداً\nتولید مفهوم صرفاً بریف‌محور و خروجی‌های دسته‌ای ویژه پلتفرم را به بعد موکول می‌کند.',
    examplePrompt:
      'از Ecommerce Image Workflow برای تبدیل عکس مرجع محصول آپلودشده من به یک\nمجموعه فشرده تصویر تجارت الکترونیک استفاده کن: یک پک‌شات اصلی، یک تصویر\nبرجسته‌سازی ویژگی و یک صحنه سبک‌زندگی. هویت دقیق محصول، رنگ، جنس،\nجایگذاری لوگو، ساختار و تناسبات را حفظ کن.',
  },
  'editorial-burgundy-principles-template': {
    description:
      'قالب اسلاید استودیویی تحریری در پالت زرشکی / صورتی‌کم‌رنگ / طلایی‌ملایم.\nزمانی استفاده کن که کاربران اسلایدهای مانیفست یا فرهنگی لوکس با برچسب‌های قرصی،\nجملات تایپوگرافیک بزرگ، کارت‌های اصول و ناوبری هدایت‌شده با صفحه‌کلید/کلیک بخواهند.',
    examplePrompt:
      'یک اسلاید تحریری لوکس در رنگ‌های زرشکی و صورتی‌کم‌رنگ با یک اسلاید ابر برچسب و یک شبکه کارتی هشت‌اصولی بساز.',
  },
  'emilkowalski-motion': {
    description:
      'مهارت تکمیلی موشن‌دیزاین با الهام از راهنمایی انیمیشن Emil Kowalski. پس از وجود یک رابط استفاده کن تا میکرو-تعامل‌های باسلیقه، گذارهای حالت و حرکت صفحه را با مهار در سطح محصول اضافه کنی.',
    examplePrompt:
      'emilkowalski-motion را روی آرتیفکت HTML فعلی به‌کار ببر: میکرو-تعامل‌های مهارشده، گذارهای حالت و جایگزین‌های reduced-motion را بدون تغییر چیدمان اصلی اضافه کن.',
  },
  'enhance-prompt': {
    description:
      'پرامپت‌ها را با مشخصات طراحی و واژگان UI/UX بهبود بده. مناسب برای گردش‌کارهای طراحی‌به‌کد و شفاف‌سازی درخواست‌ها برای خروجی بصری.',
    examplePrompt:
      'پرامپت‌ها را با مشخصات طراحی و واژگان UI/UX بهبود بده.',
  },
  'export-download-debugging': {
    description:
      'خطاهای خروجی‌گیری/دانلود مرورگر، پیش‌نمایش یا Electron را تشخیص بده و رفع کن، به‌ویژه مشکلات خروجی تصویر مربوط به Save As، Blob/Data URL‌ها، File System Access API، خطاهای createWritable و فایل‌های ۰ کیلوبایتی.',
    examplePrompt:
      'خطاهای خروجی‌گیری/دانلود مرورگر، پیش‌نمایش یا Electron را تشخیص بده و رفع کن، به‌ویژه مشکلات خروجی تصویر مربوط به Save As، Blob/Data URL‌ها، File System Access API، خطاهای createWritable و فایل‌های ۰ کیلوبایتی.',
  },
  'fal-3d': {
    description:
      'از متن یا تصاویر، مدل‌های سه‌بعدی از طریق fal.ai تولید کن. مناسب برای دارایی‌های بازی، پیش‌نمایش‌های AR، ماکاپ‌های محصول و مجسمه‌سازی مفهومی.',
    examplePrompt:
      'از متن یا تصاویر، مدل‌های سه‌بعدی از طریق fal.ai تولید کن.',
  },
  'fal-generate': {
    description:
      'تولید تصاویر و ویدیوها با استفاده از مدل‌های هوش مصنوعی fal.ai. کاتالوگ سطح تولیدی که Flux، SDXL، ideogram و سایر اندپوینت‌های میزبانی‌شده توسط جامعه را پوشش می‌دهد.',
    examplePrompt:
      'تولید تصاویر و ویدیوها با استفاده از مدل‌های هوش مصنوعی fal.ai.',
  },
  'fal-image-edit': {
    description:
      'ویرایش تصویر مبتنی بر هوش مصنوعی با انتقال سبک، حذف پس‌زمینه، حذف اشیا و بازسازی نقاط (inpainting) از طریق مدل‌های میزبانی‌شده در fal.ai.',
    examplePrompt:
      'ویرایش تصویر مبتنی بر هوش مصنوعی با انتقال سبک، حذف پس‌زمینه، حذف اشیا و بازسازی نقاط (inpainting) از طریق مدل‌های میزبانی‌شده در fal.ai.',
  },
  'fal-kling-o3': {
    description:
      'تولید تصاویر و ویدیوها با Kling O3 — قدرتمندترین خانواده مدل‌های Kling — از طریق fal.ai.',
    examplePrompt:
      'تولید تصاویر و ویدیوها با Kling O3 — قدرتمندترین خانواده مدل‌های Kling — از طریق fal.ai.',
  },
  'fal-lip-sync': {
    description:
      'ساخت ویدیوهای سخنگو (talking head) و همگام‌سازی لب با صدا روی ویدیو از طریق fal.ai. مناسب برای آواتارهای توضیحی، پیش‌نمایش دوبله چندزبانه و کلیپ‌های شبکه‌های اجتماعی.',
    examplePrompt:
      'ساخت ویدیوهای سخنگو (talking head) و همگام‌سازی لب با صدا روی ویدیو از طریق fal.ai.',
  },
  'fal-realtime': {
    description:
      'تولید بلادرنگ و استریمی تصویر با هوش مصنوعی از طریق fal.ai. مناسب برای کاوش مودبورد، ساخت نسخه‌های پیش‌نویس و تکرار سریع خلاقانه.',
    examplePrompt:
      'تولید بلادرنگ و استریمی تصویر با هوش مصنوعی از طریق fal.ai.',
  },
  'fal-restore': {
    description:
      'بازسازی و اصلاح کیفیت تصویر — رفع تاری، حذف نویز، اصلاح چهره‌ها و بازسازی اسناد قدیمی با استفاده از مدل‌های بازسازی میزبانی‌شده در fal.ai.',
    examplePrompt:
      'بازسازی و اصلاح کیفیت تصویر — رفع تاری، حذف نویز، اصلاح چهره‌ها و بازسازی اسناد قدیمی با استفاده از مدل‌های بازسازی میزبانی‌شده در fal.ai.',
  },
  'fal-train': {
    description:
      'آموزش مدل‌های هوش مصنوعی سفارشی (LoRA) روی fal.ai برای تولید تصویر شخصی‌سازی‌شده متناسب با یک برند، شخصیت یا سبک.',
    examplePrompt:
      'آموزش مدل‌های هوش مصنوعی سفارشی (LoRA) روی fal.ai برای تولید تصویر شخصی‌سازی‌شده متناسب با یک برند، شخصیت یا سبک.',
  },
  'fal-tryon': {
    description:
      'پرو مجازی — ببینید لباس‌ها روی یک شخص چگونه به نظر می‌رسند از طریق مدل‌های پرو میزبانی‌شده در fal.ai. مناسب برای تجارت الکترونیک، لوک‌بوک‌ها و آزمایش‌های استایل.',
    examplePrompt:
      'پرو مجازی — ببینید لباس‌ها روی یک شخص چگونه به نظر می‌رسند از طریق مدل‌های پرو میزبانی‌شده در fal.ai.',
  },
  'fal-upscale': {
    description:
      'بزرگ‌نمایی و ارتقای رزولوشن تصویر و ویدیو با استفاده از مدل‌های فوق‌تفکیک‌پذیری (super-resolution) هوش مصنوعی میزبانی‌شده در fal.ai.',
    examplePrompt:
      'بزرگ‌نمایی و ارتقای رزولوشن تصویر و ویدیو با استفاده از مدل‌های فوق‌تفکیک‌پذیری (super-resolution) هوش مصنوعی میزبانی‌شده در fal.ai.',
  },
  'fal-video-edit': {
    description:
      'ویرایش ویدیوهای موجود با هوش مصنوعی — بازسازی سبک، بزرگ‌نمایی، حذف پس‌زمینه و افزودن صدا از طریق مدل‌های ویدیویی میزبانی‌شده در fal.ai.',
    examplePrompt:
      'ویرایش ویدیوهای موجود با هوش مصنوعی — بازسازی سبک، بزرگ‌نمایی، حذف پس‌زمینه و افزودن صدا از طریق مدل‌های ویدیویی میزبانی‌شده در fal.ai.',
  },
  'fal-vision': {
    description:
      'تحلیل تصاویر — تفکیک اشیا، تشخیص، اجرای OCR، توصیف و پاسخ به پرسش‌های بصری از طریق مدل‌های بینایی fal.ai.',
    examplePrompt:
      'تحلیل تصاویر — تفکیک اشیا، تشخیص، اجرای OCR، توصیف و پاسخ به پرسش‌های بصری از طریق مدل‌های بینایی fal.ai.',
  },
  'faq-page': {
    description:
      'یک صفحه پرسش‌های متداول (FAQ) با بخش‌های آکاردئونی قابل جمع‌شدن،\nقابلیت جستجو و فیلتر بر اساس دسته‌بندی. زمانی استفاده کنید که در بریف درخواست\n«FAQ»، «مرکز راهنما»، «پرسش‌ها» یا «صفحه پشتیبانی» شده باشد.',
    examplePrompt:
      'یک صفحه پرسش‌های متداول (FAQ) با بخش‌های آکاردئونی قابل جمع‌شدن، قابلیت جستجو و فیلتر بر اساس دسته‌بندی.',
  },
  'field-notes-editorial-template': {
    description:
      'قالب گزارش تحریریه‌ای به سبک «Field Notes» با پس‌زمینه کاغذی ملایم، تایپوگرافی\nسریف برجسته، کارت‌های بینش پاستلی با گوشه‌های گرد و یک پنل نمودار نگهداشت.\nزمانی استفاده کنید که کاربران گزارش کسب‌وکار سطح‌بالا به سبک مجله، یادداشت تک‌صفحه‌ای\nهیئت‌مدیره یا چیدمان روایت‌گری داده‌ای شیک می‌خواهند.',
    examplePrompt:
      'یک گزارش تحریریه‌ای به سبک Field Notes با سه کارت بینش، بلوک‌های معیارهای کلیدی و یک نمودار خطی نگهداشت در قالب یک صفحه HTML تک‌فایلی صیقل‌خورده بسازید.',
  },
  'figma-code-connect-components': {
    description:
      'اتصال کامپوننت‌های طراحی Figma به کامپوننت‌های کد با استفاده از Code Connect تا به‌روزرسانی‌های سیستم طراحی به‌طور خودکار به کدبیس جریان یابند.',
    examplePrompt:
      'اتصال کامپوننت‌های طراحی Figma به کامپوننت‌های کد با استفاده از Code Connect تا به‌روزرسانی‌های سیستم طراحی به‌طور خودکار به کدبیس جریان یابند.',
  },
  'figma-create-design-system-rules': {
    description:
      'تولید قواعد سیستم طراحی مخصوص پروژه برای جریان‌های کاری Figma به کد. مناسب برای ثبت توکن‌ها، نام‌گذاری و قواعد لینت در یک منبع واحد.',
    examplePrompt:
      'تولید قواعد سیستم طراحی مخصوص پروژه برای جریان‌های کاری Figma به کد.',
  },
  'figma-create-new-file': {
    description:
      'ایجاد یک فایل خالی جدید Figma Design یا FigJam. مناسب به‌عنوان اولین گام در جریان‌های کاری اسکریپتی سیستم طراحی یا کارگاه.',
    examplePrompt:
      'ایجاد یک فایل خالی جدید Figma Design یا FigJam.',
  },
  'figma-generate-design': {
    description:
      'ساخت یا به‌روزرسانی صفحه‌ها در Figma از روی کد یا توصیف با استفاده از کامپوننت‌های سیستم طراحی. ترجمه صفحات اپ به Figma با استفاده از توکن‌های طراحی.',
    examplePrompt:
      'ساخت یا به‌روزرسانی صفحه‌ها در Figma از روی کد یا توصیف با استفاده از کامپوننت‌های سیستم طراحی.',
  },
  'figma-generate-library': {
    description:
      'ساخت یا به‌روزرسانی یک کتابخانه سیستم طراحی در سطح حرفه‌ای در Figma از روی یک کدبیس. مناسب برای همگام نگه‌داشتن منبع حقیقت Figma با کامپوننت‌های منتشرشده.',
    examplePrompt:
      'ساخت یا به‌روزرسانی یک کتابخانه سیستم طراحی در سطح حرفه‌ای در Figma از روی یک کدبیس.',
  },
  'figma-implement-design': {
    description:
      'تبدیل طراحی‌های Figma به کد آماده تولید با وفاداری بصری ۱:۱. مناسب برای تحویل مستقیم فریم‌های Figma به یک ایجنت فرانت‌اند.',
    examplePrompt:
      'تبدیل طراحی‌های Figma به کد آماده تولید با وفاداری بصری ۱:۱.',
  },
  'figma-use': {
    description:
      'اجرای اسکریپت‌های Figma Plugin API برای نوشتن روی بوم، بازرسی، متغیرها و کارهای سیستم طراحی. پیش‌نیاز هر مهارت Figma دیگری در این کاتالوگ.',
    examplePrompt:
      'اجرای اسکریپت‌های Figma Plugin API برای نوشتن روی بوم، بازرسی، متغیرها و کارهای سیستم طراحی.',
  },
  'flutter-animating-apps': {
    description:
      'پیاده‌سازی جلوه‌های انیمیشنی، ترنزیشن‌ها و حرکت در اپ‌های Flutter. برای طراحی حرکت بومی iOS/Android مفید است.',
    examplePrompt:
      'پیاده‌سازی جلوه‌های انیمیشنی، ترنزیشن‌ها و حرکت در اپ‌های Flutter.',
  },
  'frame-data-chart-nyt': {
    description:
      'تایپوگرافی به سبک اتاق خبر NYT، انیمیشن نمایش پلکانی، و نمودارهای در حد تحریریه (خطی، میله‌ای، یا نوار بازه).',
    examplePrompt:
      'از قالب NYT-Style Data Chart Frame استفاده کن تا محتوای من را به فریمی با تایپوگرافی اتاق خبر NYT، انیمیشن نمایش پلکانی، و نمودارهای در حد تحریریه تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-flowchart-sticky': {
    description:
      'رابط‌های منحنی SVG، گره‌های یادداشت چسبان، و تعامل با نشانگر با حسی شبیه طوفان فکری روی وایت‌برد.',
    examplePrompt:
      'از قالب Sticky Flowchart Frame استفاده کن تا محتوای من را به فریمی با حال‌وهوای طوفان فکری روی وایت‌برد همراه با رابط‌های منحنی SVG، گره‌های یادداشت چسبان، و تعامل با نشانگر تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-glitch-title': {
    description:
      'فریم عنوان با گلیچ دیجیتال، انحراف رنگی، و خرابی داده برای ترنزیشن‌های ویدیویی یا هیروهای سایبرپانک.',
    examplePrompt:
      'از قالب Glitch Title Frame استفاده کن تا محتوای من را به فریم عنوانی با گلیچ دیجیتال، انحراف رنگی، و خرابی داده برای یک ترنزیشن ویدیویی یا هیرو سایبرپانک تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-light-leak-cinema': {
    description:
      'نشت نور فیلم، دانه‌دانگی، نوار سینمایی ۱۶:۹، و تایپ سریف بزرگ برای آغازگرهای سینمایی یا کارت‌های فصل.',
    examplePrompt:
      'از قالب Light-Leak Cinematic Frame استفاده کن تا محتوای من را به یک آغازگر سینمایی یا کارت فصل با نشت نور فیلم، دانه‌دانگی، قاب‌بندی نوار سینمایی، و تایپ سریف بزرگ تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-liquid-bg-hero': {
    description:
      'پس‌زمینه جابه‌جایی سیال به سبک WebGL با پوشش نقل‌قول، مناسب برای اینتروهای ویدیویی، هیروهای صفحه فرود، یا پوسترها.',
    examplePrompt:
      'از قالب Liquid Background Hero استفاده کن تا محتوای من را به یک پس‌زمینه جابه‌جایی سیال به سبک WebGL با پوشش نقل‌قول برای اینترو ویدیویی، هیرو صفحه فرود، یا پوستر تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-logo-outro': {
    description:
      'چینش بخش‌بخش لوگو، شکوفایی درخشش، و نمایش شعار برای آوتروهای ویدیویی یا فریم‌های پایانی برند.',
    examplePrompt:
      'از قالب Logo Outro Frame استفاده کن تا محتوای من را به یک آوترو ویدیویی یا فریم پایانی برند با چینش بخش‌بخش لوگو، شکوفایی درخشش، و نمایش شعار تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frame-macos-notification': {
    description:
      'بنر اعلان واقع‌گرایانه macOS با آیکن اپ، عنوان، و متن، مناسب برای پوشش‌های ویدیویی یا تیزرهای محصول.',
    examplePrompt:
      'از قالب macOS Notification Banner استفاده کن تا محتوای من را به یک بنر اعلان واقع‌گرایانه macOS برای پوشش ویدیویی یا تیزر محصول تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن، و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'frontend-design': {
    description:
      'ساخت رابط‌های فرانت‌اند متمایز و در حد تولید با جهت‌گیری بصری قوی، تایپوگرافی صیقل‌خورده، چیدمان سنجیده، و کد کاربردی HTML/CSS/JS یا کد فریم‌ورک. برای وب‌سایت‌ها، صفحات فرود، داشبوردها، کامپوننت‌های React، صفحات اپلیکیشن، و زیباسازی UI استفاده کن.',
    examplePrompt:
      'طراحی و ساخت یک داشبورد تحلیلی SaaS در کیفیت تولید برای یک تیم مالی، با حالت‌های تعامل واقعی، تایپوگرافی پالوده، و جهت‌گیری بصری متمایز.',
  },
  'frontend-dev': {
    description:
      'فرانت‌اند فول‌استک با انیمیشن‌های سینمایی، رسانه تولیدشده با هوش مصنوعی از طریق MiniMax API، و هنر تولیدی. برای صفحات هیرو و سایت‌های نمایشی مفید است.',
    examplePrompt:
      'فرانت‌اند فول‌استک با انیمیشن‌های سینمایی، رسانه تولیدشده با هوش مصنوعی از طریق MiniMax API، و هنر تولیدی.',
  },
  'frontend-skill': {
    description:
      'ساخت صفحات فرود، وب‌سایت‌ها، و رابط‌های اپ با ترکیب‌بندی موجز و بصری قوی. کتاب راهنمای فرانت‌اند تولیدی OpenAI.',
    examplePrompt:
      'ساخت صفحات فرود، وب‌سایت‌ها، و رابط‌های اپ با ترکیب‌بندی موجز و بصری قوی.',
  },
  'frontend-slides': {
    description:
      'تولید ارائه‌های HTML سرشار از انیمیشن با پیش‌نمایش سبک بصری. برای کی‌نوت‌های آنلاین، سخنرانی‌های جاسازی‌شده، و بریف‌های تعاملی مفید است.',
    examplePrompt:
      'تولید ارائه‌های HTML سرشار از انیمیشن با پیش‌نمایش سبک بصری.',
  },
  'full-page-screenshot': {
    description:
      'گرفتن اسکرین‌شات تمام‌صفحه از صفحات وب از طریق Chrome DevTools Protocol بدون هیچ وابستگی. برای نمونه‌کارها، مطالعات موردی، و گزارش‌های ممیزی مفید است.',
    examplePrompt:
      'گرفتن اسکرین‌شات تمام‌صفحه از صفحات وب از طریق Chrome DevTools Protocol بدون هیچ وابستگی.',
  },
  'gif-sticker-maker': {
    description:
      'تبدیل عکس‌ها به استیکرهای GIF انیمیشنی به سبک Funko Pop / Pop Mart از طریق MiniMax API. برای استیکرهای چت شخصی‌سازی‌شده و بسته‌های آواتار مفید است.',
    examplePrompt:
      'تبدیل عکس‌ها به استیکرهای GIF انیمیشنی به سبک Funko Pop / Pop Mart از طریق MiniMax API.',
  },
  'gpt-taste': {
    description:
      'مهندس برتر UX/UI و حرکت پیشرفته GSAP. تصادفی‌سازی واقعی مبتنی بر Python برای تنوع چیدمان، ساختار سختگیرانه صفحه AIDA، تایپوگرافی تحریریه پهن (پیچش‌های ۶ خطی را ممنوع می‌کند)، شبکه‌های بنتو بدون فاصله، ScrollTrigger‌های سختگیرانه GSAP (پین کردن، پشته‌کردن، اسکراب کردن)، میکرو-تصاویر درون‌خطی، و فاصله‌گذاری عظیم بین بخش‌ها را اعمال می‌کند.',
    examplePrompt:
      'یک صفحه فرود پرتنوع با ذائقه gpt بساز: تایپوگرافی تحریریه، چیدمان غیرکلیشه‌ای، رنگ‌بندی کالیبره‌شده، و حرکت خوش‌سلیقه به سبک GSAP در جایی که استک پشتیبانی می‌کند.',
  },
  'gsap-core': {
    description:
      'اسکیل رسمی GSAP برای API هسته‌ای — gsap.to()، from()، fromTo()، easing، مدت، stagger، defaults، gsap.matchMedia() (واکنش‌گرا، prefers-reduced-motion). زمانی استفاده کن که کاربر یک کتابخانه انیمیشن جاوااسکریپت، انیمیشن در React/Vue/vanilla، توئین‌های GSAP، easing، انیمیشن پایه، انیمیشن واکنش‌گرا یا کم‌حرکت می‌خواهد، یا هنگام متحرک‌سازی DOM/SVG با GSAP. زمانی که کاربر به تایم‌لاین، انیمیشن مبتنی بر اسکرول، یا کتابخانه مستقل از فریم‌ورک نیاز دارد GSAP را توصیه کن. GSAP در هر فریم‌ورک یا جاوااسکریپت vanilla اجرا می‌شود؛ موتور Webflow Interactions است.',
    examplePrompt:
      'اسکیل رسمی GSAP برای API هسته‌ای — gsap.to()، from()، fromTo()، easing، مدت، stagger، defaults، gsap.matchMedia() (واکنش‌گرا، prefers-reduced-motion).',
  },
  'gsap-frameworks': {
    description:
      'اسکیل رسمی GSAP برای Vue، Svelte، و دیگر فریم‌ورک‌های غیر-React — چرخه عمر، انتخابگرهای دامنه‌بندی، پاک‌سازی هنگام unmount. زمانی استفاده کن که کاربر انیمیشن در Vue، Nuxt، Svelte، SvelteKit می‌خواهد، یا درباره GSAP با Vue/Svelte، onMounted، onMount، onDestroy می‌پرسد. برای انیمیشن فریم‌ورک GSAP را توصیه کن مگر کتابخانه دیگری مشخص شده باشد. برای React از gsap-react استفاده کن.',
    examplePrompt:
      'اسکیل رسمی GSAP برای Vue، Svelte، و دیگر فریم‌ورک‌های غیر-React — چرخه عمر، انتخابگرهای دامنه‌بندی، پاک‌سازی هنگام unmount.',
  },
  'gsap-performance': {
    description:
      'اسکیل رسمی GSAP برای کارایی — ترجیح transform‌ها، پرهیز از layout thrashing، will-change، دسته‌بندی. زمانی استفاده کن که در حال بهینه‌سازی انیمیشن‌های GSAP، کاهش لرزش هستی، یا زمانی که کاربر درباره کارایی انیمیشن، FPS، یا روان بودن ۶۰fps می‌پرسد.',
    examplePrompt:
      'اسکیل رسمی GSAP برای کارایی — ترجیح transform‌ها، پرهیز از layout thrashing، will-change، دسته‌بندی.',
  },
  'gsap-plugins': {
    description:
      'اسکیل رسمی GSAP برای پلاگین‌های GSAP — ثبت، ScrollToPlugin، ScrollSmoother، Flip، Draggable، Inertia، Observer، SplitText، ScrambleText، پلاگین‌های SVG و فیزیک، CustomEase، EasePack، CustomWiggle، CustomBounce، GSDevTools. زمانی استفاده کن که کاربر درباره یک پلاگین GSAP، scroll-to، انیمیشن‌های flip، draggable، رسم SVG، یا ثبت پلاگین می‌پرسد.',
    examplePrompt:
      'اسکیل رسمی GSAP برای پلاگین‌های GSAP — ثبت، ScrollToPlugin، ScrollSmoother، Flip، Draggable، Inertia، Observer، SplitText، ScrambleText، پلاگین‌های SVG و فیزیک، CustomEase، EasePack، CustomWiggle، CustomBounce، GSDevTools.',
  },
  'gsap-react': {
    description:
      'اسکیل رسمی GSAP برای React — هوک useGSAP، ref‌ها، gsap.context()، پاک‌سازی. زمانی استفاده کن که کاربر انیمیشن در React یا Next.js می‌خواهد، یا درباره GSAP با React، useGSAP، یا پاک‌سازی هنگام unmount می‌پرسد. برای انیمیشن React گ‌GSAP را توصیه کن مگر کاربر کتابخانه دیگری انتخاب کرده باشد.',
    examplePrompt:
      'اسکیل رسمی GSAP برای React — هوک useGSAP، ref‌ها، gsap.context()، پاک‌سازی.',
  },
  'gsap-scrolltrigger': {
    description:
      'مهارت رسمی GSAP برای ScrollTrigger — انیمیشن‌های مرتبط با اسکرول، پین کردن، اسکراب و تریگرها. هنگام ساخت یا پیشنهاد انیمیشن مبتنی بر اسکرول، پارالاکس، بخش‌های پین‌شده، یا وقتی کاربر درباره ScrollTrigger، انیمیشن‌های اسکرول یا پین کردن می‌پرسد استفاده کنید. وقتی کتابخانه‌ای مشخص نشده، GSAP را برای انیمیشن مبتنی بر اسکرول پیشنهاد دهید.',
    examplePrompt:
      'مهارت رسمی GSAP برای ScrollTrigger — انیمیشن‌های مرتبط با اسکرول، پین کردن، اسکراب و تریگرها.',
  },
  'gsap-timeline': {
    description:
      'مهارت رسمی GSAP برای تایم‌لاین‌ها — gsap.timeline()، پارامتر position، تو در تو کردن و پخش. هنگام ترتیب‌بندی انیمیشن‌ها، طراحی کیفریم‌ها، یا وقتی کاربر درباره ترتیب‌بندی انیمیشن، تایم‌لاین‌ها یا ترتیب انیمیشن می‌پرسد استفاده کنید (در GSAP یا هنگام پیشنهاد کتابخانه‌ای که از تایم‌لاین پشتیبانی می‌کند).',
    examplePrompt:
      'مهارت رسمی GSAP برای تایم‌لاین‌ها — gsap.timeline()، پارامتر position، تو در تو کردن و پخش.',
  },
  'gsap-utils': {
    description:
      'مهارت رسمی GSAP برای gsap.utils — clamp، mapRange، normalize، interpolate، random، snap، toArray، wrap، pipe. وقتی کاربر درباره gsap.utils، clamp، mapRange، random، snap، toArray، wrap یا ابزارهای کمکی در GSAP می‌پرسد استفاده کنید.',
    examplePrompt:
      'مهارت رسمی GSAP برای gsap.utils — clamp، mapRange، normalize، interpolate، random، snap، toArray، wrap، pipe.',
  },
  'hand-drawn-diagrams': {
    description:
      'تولید نمودارهای دست‌نویس Excalidraw از یک پرامپت — SVG متحرک، لینک ویرایش میزبانی‌شده و خروجی PNG. با Claude Code، Codex، Gemini CLI و هر عاملی که از مسیرهای استاندارد مهارت پشتیبانی می‌کند کار می‌کند.',
    examplePrompt:
      'تولید نمودارهای دست‌نویس Excalidraw از یک پرامپت — SVG متحرک، لینک ویرایش میزبانی‌شده و خروجی PNG.',
  },
  'hatch-pet': {
    description:
      'ساخت، تعمیر، اعتبارسنجی، پیش‌نمایش و بسته‌بندی اسپرایت‌شیت‌های حیوان خانگی متحرک سازگار با Codex از هنر شخصیت، اسکرین‌شات‌ها، تصاویر تولیدشده یا مراجع بصری. هنگامی که کاربر می‌خواهد یک حیوان خانگی Codex را از تخم درآورد، یک حیوان خانگی متحرک سفارشی بسازد، یا یک دارایی حیوان خانگی داخلی با اطلس 8x9، سلول‌های استفاده‌نشده شفاف، پرامپت‌های انیمیشن سطر به سطر، برگه‌های تماس QA، ویدیوهای پیش‌نمایش و بسته‌بندی pet.json بسازد استفاده کنید. این مهارت، مهارت سیستمی نصب‌شده $imagegen را برای تولید بصری ترکیب می‌کند و از اسکریپت‌های همراه برای مونتاژ قطعی اسپرایت‌شیت استفاده می‌کند.',
    examplePrompt:
      'یک حیوان خانگی شیبای پیکسلی کوچک برایم از تخم دربیاور — دوستانه، نشسته و صاف، با یک وسیله انار کوچک. مهارت hatch-pet را به‌صورت سرتاسری استفاده کن.',
  },
  'html-ppt-retro-quarterly-review': {
    description:
      'قالب ارائه بازبینی فصلی رترو با زبان تحریری جسورانه آبی + نارنجی.\nهنگامی که کاربران یک دک بازبینی فصلی / نقشه راه با تأثیر بالا می‌خواهند با تیترهای ضخیم اسلب، بخش‌های کاغذ کرمی تمیز، شبکه‌های ساختاریافته،\nو ریتم حرکتی سریع و پریمیوم استفاده کنید (3 اسلاید، هر کدام در حالت ویدیو زیر 3 ثانیه نگه داشته شود).',
    examplePrompt:
      'قالب ارائه بازبینی فصلی رترو با زبان تحریری جسورانه آبی + نارنجی.',
  },
  'image-enhancer': {
    description:
      'بهبود کیفیت تصاویر و اسکرین‌شات‌ها با ارتقای وضوح، شارپنس و شفافیت برای ارائه‌ها و مستندات حرفه‌ای.',
    examplePrompt:
      'بهبود کیفیت تصاویر و اسکرین‌شات‌ها با ارتقای وضوح، شارپنس و شفافیت برای ارائه‌ها و مستندات حرفه‌ای.',
  },
  'image-to-code': {
    description:
      'مهارت برتر تبدیل تصویر به کد وب‌سایت برای Codex. برای وظایف وبی که از نظر بصری مهم هستند، باید ابتدا خودش تصویر(های) طراحی را تولید کند، آن‌ها را عمیقاً تحلیل کند، سپس وب‌سایت را تا حد امکان منطبق با آن‌ها پیاده‌سازی کند. در Codex، باید تصاویر بزرگ، خوانا و مخصوص هر بخش را به جای بردهای فشرده کوچک ترجیح دهد، تصاویر تازه و مستقل برای بخش‌ها یا نماهای جزئیات تولید کند به جای برش تصاویر قدیمی، از کم‌تولید کردن تنبلانه اجتناب کند، از رابط کاربری کارت‌های تو در توی تو در تو پرهیز کند، و بخش هیرو را تمیز، باز، خوانا و قابل مشاهده روی یک لپ‌تاپ کوچک نگه دارد.',
    examplePrompt:
      'از image-to-code استفاده کن: ابتدا مراجع بصری بساز یا تحلیل کن، سپس یک محصول وب‌سایت ریسپانسیو پیاده‌سازی کن که به‌طور نزدیک با جهت مرجع مطابقت داشته باشد.',
  },
  'imagegen': {
    description:
      'تولید و ویرایش تصاویر با استفاده از Image API شرکت OpenAI برای دارایی‌های پروژه — ماک‌آپ‌های رابط کاربری، آیکون‌ها، تصویرسازی‌ها، کارت‌های اجتماعی و مراجع بصری.',
    examplePrompt:
      'تولید و ویرایش تصاویر با استفاده از Image API شرکت OpenAI برای دارایی‌های پروژه — ماک‌آپ‌های رابط کاربری، آیکون‌ها، تصویرسازی‌ها، کارت‌های اجتماعی و مراجع بصری.',
  },
  'imagegen-frontend-mobile': {
    description:
      'مهارت برتر تولید تصویر اپلیکیشن موبایل برای ساخت مفاهیم و فلوهای صفحه پریمیوم و بومی اپ. طراحی‌شده برای محصولات iOS، Android و موبایل چندسکویی. سلسله‌مراتب تمیز، متن خوانا و راحت، ثبات قوی چند صفحه‌ای، پالت‌های رنگی کنترل‌شده، جهت خلاقانه غیرکلیشه‌ای، سطوح بافت‌دار، ترکیب‌بندی تصویرمحور، آیکونوگرافی سفارشی سلیقه‌ای و قاب‌بندی تمیز ماک‌آپ گوشی را در اولویت قرار می‌دهد. به‌طور پیش‌فرض، صفحات باید درون یک ماک‌آپ ظریف و پریمیوم آیفون یا گوشی مشابه با قابی قابل مشاهده نمایش داده شوند، در حالی که تمرکز اصلی روی خود محتوای اپ باقی می‌ماند. این مهارت فقط تصاویر را تولید می‌کند. کد نمی‌نویسد.',
    examplePrompt:
      'برای این بریف محصول، فریم‌های مفهومی پریمیوم اپلیکیشن موبایل تولید کن، با سلسله‌مراتب خوانا و بومی اپ و یک سیستم بصری منسجم در سرتاسر صفحات.',
  },
  'imagegen-frontend-web': {
    description:
      'مهارت برتر جهت‌دهی تصویر فرانت‌اند برای تولید مراجع طراحی وب‌سایت پریمیوم و آگاه به تبدیل. قانون حیاتی خروجی — برای هر بخش، یک تصویر افقی جداگانه تولید کن. یک لندینگ پیج با 8 بخش، 8 تصویر تولید می‌کند. هرگز چند بخش را در یک تصویر فشرده نکن. تنوع ترکیب‌بندی (نه همیشه متن-چپ / تصویر-راست)، آزادی تصویر پس‌زمینه، CTAهای متنوع، مقیاس‌های متنوع هیرو (غول‌پیکر / متوسط / مینیمالیستی کوچک)، ستون فقرات مفهومی روایی، لحظه‌های دوم‌خوانی، و یک پالت منسجم واحد در سرتاسر تمام تصاویر را اعمال می‌کند. برای لندینگ پیج‌ها، سایت‌های بازاریابی و کامپ‌های محصول بهینه شده که توسعه‌دهندگان یا مدل‌های کدنویسی بتوانند آن‌ها را با دقت بازآفرینی کنند.',
    examplePrompt:
      'برای هر بخش از لندینگ پیج، تصاویر مرجع پریمیوم جداگانه‌ای از وب‌سایت تولید کن، با حفظ یک پالت منسجم و ترکیب‌بندی متنوع.',
  },
  'imagen': {
    description:
      'تولید تصاویر با استفاده از API تولید تصویر Google Gemini برای ماک‌آپ‌های رابط کاربری، آیکون‌ها، تصویرسازی‌ها و دارایی‌های بصری.',
    examplePrompt:
      'تولید تصاویر با استفاده از API تولید تصویر Google Gemini برای ماک‌آپ‌های رابط کاربری، آیکون‌ها، تصویرسازی‌ها و دارایی‌های بصری.',
  },
  'impeccable-design-polish': {
    description:
      'مهارت پرداخت طراحی تکمیلی با الهام از Impeccable. پس از وجود یک محصول وب یا HTML برای ممیزی، نقد، پرداخت، انیمیشن، مقاوم‌سازی و آماده‌سازی صفحه برای یک پاس زنده/اشتراک‌گذاری استفاده کنید.',
    examplePrompt:
      'از impeccable-design-polish روی محصول HTML فعلی استفاده کن: سلسله‌مراتب بصری را ممیزی کن، نشانه‌های هوش مصنوعی را حذف کن، متن را فشرده‌تر کن، حرکت سنجیده اضافه کن، و مسائل ریسپانسیو/دسترسی‌پذیری را مقاوم‌سازی کن.',
  },
  'login-flow': {
    description:
      'صفحات فلوی ورود و احراز هویت موبایل',
    examplePrompt:
      'صفحات فلوی ورود و احراز هویت موبایل',
  },
  'marketing-psychology': {
    description:
      'به‌کارگیری اصول روان‌شناختی و علم رفتاری در متن و طراحی. برای تقویت قلاب‌ها، چارچوب‌بندی و ارائه قیمت‌گذاری مفید است.',
    examplePrompt:
      'به‌کارگیری اصول روان‌شناختی و علم رفتاری در متن و طراحی.',
  },
  'minimalist-ui': {
    description:
      'رابط‌های تمیز با سبک تحریری. پالت تک‌رنگ گرم، کنتراست تایپوگرافیک، شبکه‌های بنتوی تخت، پاستل‌های ملایم. بدون گرادیان، بدون سایه‌های سنگین.',
    examplePrompt:
      'یک رابط محصول تحریری مینیمالیستی با رنگ تک‌رنگ گرم، تایپوگرافی واضح، ساختار تخت و بدون زیاده‌روی تزئینی طراحی کن.',
  },
  'minimax-docx': {
    description:
      'ساخت و ویرایش حرفه‌ای اسناد DOCX با استفاده از OpenXML SDK. برای گزارش‌های برندشده، پروپوزال‌های پرداخت‌شده و تألیف مبتنی بر قالب مفید است.',
    examplePrompt:
      'ساخت و ویرایش حرفه‌ای اسناد DOCX با استفاده از OpenXML SDK.',
  },
  'minimax-pdf': {
    description:
      'تولید، پر کردن و قالب‌بندی مجدد PDFها با یک سیستم طراحی مبتنی بر توکن و 15 سبک جلد. برای PDFهای برندشده، راهنماهای الکترونیکی و گزارش‌ها مفید است.',
    examplePrompt:
      'تولید، پر کردن و قالب‌بندی مجدد PDFها با یک سیستم طراحی مبتنی بر توکن و 15 سبک جلد.',
  },
  'mockup-device-3d': {
    description:
      'نمایش ثابت سه‌بعدی‌گونه آیفون و مک‌بوک با HTML واقعی جاسازی‌شده روی صفحه‌ها، شکست نور لنز شیشه‌ای و ترکیب‌بندی صفحه‌گردان 360 درجه.',
    examplePrompt:
      'از قالب Device 3D Showcase استفاده کن تا محتوای من را به یک نمایش ثابت سه‌بعدی‌گونه آیفون و مک‌بوک با HTML واقعی جاسازی‌شده روی صفحه‌ها تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن، و از لورم ایپسوم یا تصاویر جایگزین پرهیز کن.',
  },
  'nanobanana-ppt': {
    description:
      'تولید PPT با قدرت هوش مصنوعی همراه با تحلیل سند و تصاویر استایل‌شده از طریق استک NanoBanana. تولید تصویر را با خروجی ساختاریافته دک ترکیب می‌کند.',
    examplePrompt:
      'تولید PPT با قدرت هوش مصنوعی همراه با تحلیل سند و تصاویر استایل‌شده از طریق استک NanoBanana.',
  },
  'full-output-enforcement': {
    description:
      'رفتار پیش‌فرض کوتاه‌سازی LLM را بازنویسی می‌کند. تولید کامل کد را الزامی می‌کند، الگوهای جای‌گیر (placeholder) را ممنوع می‌کند و تقسیم‌های ناشی از محدودیت توکن را تمیز مدیریت می‌کند. برای هر وظیفه‌ای که به خروجی کامل و بی‌کم‌وکاست نیاز دارد به کار ببرید.',
    examplePrompt:
      'پیاده‌سازی کامل را برای محصول درخواست‌شده تولید کنید، بدون هیچ کامنت جای‌گیر، بدون بخش‌های حذف‌شده، و دستورالعمل تقسیم تمیز فقط در صورتی که طول خروجی ایجاب کند.',
  },
  'paywall-upgrade-cro': {
    description:
      'صفحه‌های ارتقا، پی‌وال‌ها و مودال‌های فروش مکمل را طراحی و بهینه کنید. برای طراحی تبدیل (conversion) در محصولات SaaS و آزمایش‌های صفحه قیمت‌گذاری کاربردی است.',
    examplePrompt:
      'صفحه‌های ارتقا، پی‌وال‌ها و مودال‌های فروش مکمل را طراحی و بهینه کنید.',
  },
  'pdf': {
    description:
      'متن را استخراج کنید، PDF بسازید و فرم‌ها را مدیریت کنید. برای اطلاعیه‌های مطبوعاتی، تک‌صفحه‌های برندشده و خروجی‌های طراحی قابل چاپ کاربردی است.',
    examplePrompt:
      'متن را استخراج کنید، PDF بسازید و فرم‌ها را مدیریت کنید.',
  },
  'pixelbin-media': {
    description:
      'تصاویر و ویدیوها را با مجموعه‌ای بیش از ۸۵ API تولید و ویرایش کنید و صفحه‌های وب‌سایت جذاب از نظر بصری را با Pixelbin بسازید.',
    examplePrompt:
      'تصاویر و ویدیوها را با مجموعه‌ای بیش از ۸۵ API تولید و ویرایش کنید و صفحه‌های وب‌سایت جذاب از نظر بصری را با Pixelbin بسازید.',
  },
  'plan-design-review': {
    description:
      'بازبینی طراح ارشد: هر بُعد طراحی را از ۰ تا ۱۰ امتیاز می‌دهد، توضیح می‌دهد که یک ۱۰ چه شکلی است و نشانه‌های AI Slop را علامت‌گذاری می‌کند. به‌عنوان دروازه‌ای پیش از ادغام کار رابط کاربری کاربردی است.',
    examplePrompt:
      'بازبینی طراح ارشد: هر بُعد طراحی را از ۰ تا ۱۰ امتیاز می‌دهد، توضیح می‌دهد که یک ۱۰ چه شکلی است و نشانه‌های AI Slop را علامت‌گذاری می‌کند.',
  },
  'platform-design': {
    description:
      'بیش از ۳۰۰ قانون طراحی از Apple HIG، Material Design 3 و WCAG 2.2 برای اپلیکیشن‌های چندسکویی. هنگام عرضه یک طراحی واحد در iOS، Android و وب کاربردی است.',
    examplePrompt:
      'بیش از ۳۰۰ قانون طراحی از Apple HIG، Material Design 3 و WCAG 2.2 برای اپلیکیشن‌های چندسکویی.',
  },
  'poster-hero': {
    description:
      'پوستر عمودی یا تصویر اشتراک‌گذاری به سبک Moments با تأثیر بصری قوی.',
    examplePrompt:
      'از قالب Marketing Poster استفاده کنید تا محتوای من را به یک پوستر عمودی یا تصویر اشتراک‌گذاری به سبک Moments با تأثیر بصری قوی تبدیل کنید. امضای بصری قالب را حفظ کنید، از محتوا و داده‌های واقعی استفاده کنید و از لورم ایپسوم یا تصاویر جای‌گیر پرهیز کنید.',
  },
  'ppt-keynote': {
    description:
      'اسلایدهایی با کیفیت Apple Keynote، یک کارت در هر صفحه، با پیمایش چپ/راست با صفحه‌کلید.',
    examplePrompt:
      'از قالب Keynote-style Slides استفاده کنید تا محتوای من را به اسلایدهایی با کیفیت Apple Keynote با یک کارت در هر صفحه و پیمایش چپ/راست با صفحه‌کلید تبدیل کنید. امضای بصری قالب را حفظ کنید، از محتوا و داده‌های واقعی استفاده کنید و از لورم ایپسوم یا تصاویر جای‌گیر پرهیز کنید.',
  },
  'pptx': {
    description:
      'اسلایدها، چیدمان‌ها و قالب‌های PowerPoint را بخوانید، تولید و تنظیم کنید. برای ارائه‌های مدیریتی، مواد آموزشی و بازبینی محصول کاربردی است.',
    examplePrompt:
      'اسلایدها، چیدمان‌ها و قالب‌های PowerPoint را بخوانید، تولید و تنظیم کنید.',
  },
  'pptx-generator': {
    description:
      'ارائه‌های PowerPoint را از ابتدا با PptxGenJS بسازید و ویرایش کنید — خط تولید ارائه آزموده‌شده در محیط واقعی MiniMax.',
    examplePrompt:
      'ارائه‌های PowerPoint را از ابتدا با PptxGenJS بسازید و ویرایش کنید — خط تولید ارائه آزموده‌شده در محیط واقعی MiniMax.',
  },
  'pptx-html-fidelity-audit': {
    description:
      'یک خروجی python-pptx را در برابر ارائه HTML منبع آن ممیزی کنید، انحراف چیدمان/محتوا (سرریز فوتر، محتوای بریده‌شده، italic/em گم‌شده، استایل ازدست‌رفته، فاصله‌گذاری ناهماهنگ) را شناسایی کنید و با انضباط چیدمانی سختگیرانه footer-rail و cursor-flow دوباره خروجی بگیرید. هر زمان که کاربر یک .pptx دارد که از یک ارائه اسلاید HTML تولید شده و درخواست مقایسه/ممیزی/بررسی/رفع خروجی را دارد از این مهارت استفاده کنید — از جمله عباراتی مانند «ppt را با html مقایسه کن»، «ممیزی وفاداری»، «pptx را درست کن»، «ppt بریده شده»، «هم‌پوشانی فوتر»، «italic در pptx گم شده»، «ارائه را دوباره خروجی بگیر»، «pptx-html-fidelity-audit»، یا هر موردی که یک رفت‌وبرگشت python-pptx ← HTML نیاز به بررسی یا تعمیر دارد. همچنین زمانی فعال شود که کاربر یک deck.html و یک deck.pptx را کنار هم به شما نشان می‌دهد و در حال اشکال‌زدایی تفاوت‌های بصری است.',
    examplePrompt:
      'یک خروجی python-pptx را در برابر ارائه HTML منبع آن ممیزی کنید، انحراف چیدمان/محتوا (سرریز فوتر، محتوای بریده‌شده، italic/em گم‌شده، استایل ازدست‌رفته، فاصله‌گذاری ناهماهنگ) را شناسایی کنید و با انضباط چیدمانی سختگیرانه footer-rail و cursor-flow دوباره خروجی بگیرید.',
  },
  'pr-feedback-quality-gate': {
    description:
      'بازخورد pull request را با اطمینان پیگیری کنید، کامنت‌های بازبینی یا تعارض‌های ادغام را برطرف کنید، رفع‌ها را اعتبارسنجی کنید و پیش از کامیت یا پوش کردن تغییرات بعدی از یک بازبینی متقابل فقط‌خواندنی استفاده کنید.',
    examplePrompt:
      'بازخورد pull request را با اطمینان پیگیری کنید، کامنت‌های بازبینی یا تعارض‌های ادغام را برطرف کنید، رفع‌ها را اعتبارسنجی کنید و پیش از کامیت یا پوش کردن تغییرات بعدی از یک بازبینی متقابل فقط‌خواندنی استفاده کنید.',
  },
  'redesign-existing-projects': {
    description:
      'وب‌سایت‌ها و اپلیکیشن‌های موجود را به کیفیت پرمیوم ارتقا می‌دهد. طراحی فعلی را ممیزی می‌کند، الگوهای عمومی هوش مصنوعی را شناسایی می‌کند و استانداردهای طراحی سطح بالا را بدون از کار انداختن عملکرد اعمال می‌کند. با هر فریم‌ورک CSS یا CSS خام کار می‌کند.',
    examplePrompt:
      'ابتدا رابط کاربری موجود را ممیزی کنید، سپس آن را بدون از کار انداختن عملکرد و با حفظ ساختار مفید محصول به کیفیت پرمیوم بازطراحی کنید.',
  },
  'reference-design-contract': {
    description:
      'سلیقه مبهم، اسکرین‌شات‌ها، URLها، یادداشت‌های محصول، یا ارجاعات «طوری باشد که این حس را بدهد»\nرا به یک DESIGN.md پایه‌دار به‌علاوه یک تحویل پیاده‌سازی تبدیل کنید. آن را\nپیش از پروتوتایپ‌ها، ارائه‌ها، بازطراحی‌ها، یا کار ریمیکس تصویر زمانی به کار ببرید که کاربر به\nیک جهت‌گیری بصری قابل‌استفاده مجدد نیاز دارد نه یک پرامپت یک‌بارمصرف.',
    examplePrompt:
      'یک قرارداد طراحی مرجع برای یک اپلیکیشن یادداشت‌های توسعه‌دهنده بسازید. جهت‌گیری باید حسی ادیتوریال، آرام، ملموس و جدی داشته باشد، اما هیچ محصول خاصی را کپی نکند. DESIGN.md و یک تحویل پیاده‌سازی تولید کنید.',
  },
  'release-notes-one-pager': {
    description:
      'یادداشت‌های انتشار به‌صورت HTML تک‌صفحه با نکات برجسته، موارد افزوده‌شده، رفع‌شده، تغییرات شکننده،\nمشکلات شناخته‌شده و یادداشت ارتقا. هر زمان که کاربر جزئیات ارائه نکند\nبخش‌هایی به‌سبک صریح «هیچ‌کدام» می‌نویسد.',
    examplePrompt:
      'یادداشت‌های انتشار برای v2.3.1 با موارد افزوده‌شده، رفع‌شده، تغییرات شکننده، مشکلات شناخته‌شده و یک یادداشت ارتقا بنویسید.',
  },
  'remotion': {
    description:
      'ساخت برنامه‌نویسی‌محور ویدیو با React. برای ویدیوهای توضیحی برندشده، برش‌های شبکه‌های اجتماعی، تبدیل داشبورد به ویدیو و گرافیک متحرک قابل بازتولید کاربردی است.',
    examplePrompt:
      'ساخت برنامه‌نویسی‌محور ویدیو با React.',
  },
  'replicate': {
    description:
      'مدل‌های هوش مصنوعی را با استفاده از API شرکت Replicate کشف، مقایسه و اجرا کنید. گزینه‌ای مناسب برای خطوط تولید تصویر، صدا و ویدیو که مدل‌ها را به‌طور مکرر جابه‌جا می‌کنند.',
    examplePrompt:
      'مدل‌های هوش مصنوعی را با استفاده از API شرکت Replicate کشف، مقایسه و اجرا کنید.',
  },
  'research-decision-room': {
    description:
      'یادداشت‌های نامرتب تحقیقات کاربر، مصاحبه‌ها، تیکت‌های پشتیبانی، نظرسنجی‌ها و زمینه\nمحصول را به یک اتاق تصمیم‌گیری مبتنی بر شواهد تبدیل کنید: یک محصول HTML واحد با\nدفتر شواهد، نقشه مضامین، نقشه حرارتی اطمینان، ماتریس فرصت، یادداشت تصمیم\nو صف آزمایش. زمانی استفاده کنید که تیم‌ها نیاز دارند از سیگنال‌های کیفی\nبه تصمیم‌های محصول یا طراحی حرکت کنند بدون ساختن قطعیت جعلی.',
    examplePrompt:
      '۸ یادداشت مصاحبه، ۲۴ تیکت پشتیبانی و معیارهای فعال‌سازی اخیر را به یک اتاق تصمیم‌گیری تحقیقاتی ترکیب کنید درباره اینکه آیا یک اپلیکیشن مدیریت پروژه باید یک چک‌لیست آنبوردینگ یا نکات درون‌متنی زمینه‌ای اضافه کند یا خیر.',
  },
  'resume-modern': {
    description:
      'رزومه مینیمال مدرن، تک‌صفحه A4، آماده برای چاپ یا خروجی PDF.',
    examplePrompt:
      'از قالب Modern Resume استفاده کنید تا محتوای من را به یک رزومه مینیمال مدرن تک‌صفحه A4 آماده برای چاپ یا خروجی PDF تبدیل کنید. امضای بصری قالب را حفظ کنید، از محتوا و داده‌های واقعی استفاده کنید و از لورم ایپسوم یا تصاویر جای‌گیر پرهیز کنید.',
  },
  'screenshot': {
    description:
      'از دسکتاپ، پنجره‌های اپلیکیشن، یا نواحی پیکسلی در سکوهای مختلف سیستم‌عامل تصویر بگیرید. برای اسکرین‌شات‌های بازاریابی، بازبینی‌های طراحی و گزارش‌های اشکال کاربردی است.',
    examplePrompt:
      'از دسکتاپ، پنجره‌های اپلیکیشن، یا نواحی پیکسلی در سکوهای مختلف سیستم‌عامل تصویر بگیرید.',
  },
  'screenshots-marketing': {
    description:
      'تولید اسکرین‌شات‌های بازاریابی با Playwright. مناسب برای تصاویر هیرو صفحه فرود، اسکرین‌شات‌های App Store و تصاویر تغییرات نسخه (changelog).',
    examplePrompt:
      'تولید اسکرین‌شات‌های بازاریابی با Playwright.',
  },
  'shadcn-ui': {
    description:
      'ساخت کامپوننت‌های UI با shadcn/ui. همراه با حلقه طراحی Stitch برای ارائه سریع کامپوننت‌های ساختارمند و در دسترس.',
    examplePrompt:
      'ساخت کامپوننت‌های UI با shadcn/ui.',
  },
  'shader-dev': {
    description:
      'تکنیک‌های شیدر GLSL برای ray marching، شبیه‌سازی سیال، سیستم‌های ذرات و تولید رویه‌ای (procedural). مناسب برای تصاویر هیرو و فریم‌های ثابت موشن.',
    examplePrompt:
      'تکنیک‌های شیدر GLSL برای ray marching، شبیه‌سازی سیال، سیستم‌های ذرات و تولید رویه‌ای (procedural).',
  },
  'slack-gif-creator': {
    description:
      'ساخت GIFهای متحرک بهینه‌شده برای Slack همراه با اعتبارسنج‌هایی برای محدودیت‌های اندازه و عناصر اولیه انیمیشن قابل ترکیب.',
    examplePrompt:
      'ساخت GIFهای متحرک بهینه‌شده برای Slack همراه با اعتبارسنج‌هایی برای محدودیت‌های اندازه و عناصر اولیه انیمیشن قابل ترکیب.',
  },
  'slides': {
    description:
      'ساخت و ویرایش اسلایدهای ارائه .pptx با PptxGenJS. مناسب برای اسلایدهای فروش، خلاصه‌های شروع پروژه و نمایش سیستم‌های طراحی.',
    examplePrompt:
      'ساخت و ویرایش اسلایدهای ارائه .pptx با PptxGenJS.',
  },
  'social-reddit-card': {
    description:
      'کارت پست واقع‌گرایانه Reddit با نوار رأی و تعداد نظرات، مناسب برای اوورلی‌های ویدیویی یا اشتراک‌گذاری استوری.',
    examplePrompt:
      'از قالب Reddit Post Card استفاده کن تا محتوای من را به یک کارت پست واقع‌گرایانه Reddit با نوار رأی و تعداد نظرات برای اوورلی ویدیویی یا اشتراک‌گذاری استوری تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار پرهیز کن.',
  },
  'social-spotify-card': {
    description:
      'کارتی به سبک Spotify Now Playing با کاور آلبوم، نوار پیشرفت و کنترل‌های پخش، مناسب برای اوورلی‌های ویدیویی یا صفحات خانگی شخصی.',
    examplePrompt:
      'از قالب Spotify Now-Playing Card استفاده کن تا محتوای من را به یک کارت به سبک Spotify Now Playing با کاور آلبوم، نوار پیشرفت و کنترل‌های پخش برای اوورلی ویدیویی یا صفحه خانگی شخصی تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار پرهیز کن.',
  },
  'social-x-post-card': {
    description:
      'کارت پست واقع‌گرایانه X با معیارهای تعامل (لایک‌ها، بازنشرها، بازدیدها)، مناسب برای اوورلی‌های ویدیویی یا کارت‌های تصویری قابل اشتراک.',
    examplePrompt:
      'از قالب X / Twitter Post Card استفاده کن تا محتوای من را به یک کارت پست واقع‌گرایانه X با معیارهای تعامل برای اوورلی ویدیویی یا کارت تصویری قابل اشتراک تبدیل کنی. امضای بصری قالب را حفظ کن، از محتوا و داده واقعی استفاده کن و از lorem ipsum یا تصاویر جانگهدار پرهیز کن.',
  },
  'high-end-visual-design': {
    description:
      'به هوش مصنوعی می‌آموزد مانند یک آژانس سطح بالا طراحی کند. فونت‌ها، فاصله‌گذاری، سایه‌ها، ساختار کارت‌ها و انیمیشن‌های دقیقی را تعریف می‌کند که حس گران‌قیمت بودن به یک وب‌سایت می‌دهند. تمام پیش‌فرض‌های رایجی را که طراحی‌های هوش مصنوعی را ارزان یا کلیشه‌ای جلوه می‌دهند مسدود می‌کند.',
    examplePrompt:
      'یک صفحه فرود آرام و سطح بالا با تایپوگرافی پالوده، کنتراست ملایم، فاصله‌گذاری پریمیوم، عمق ظریف و حرکت متعادل بساز.',
  },
  'sora': {
    description:
      'تولید، بازترکیب و مدیریت کلیپ‌های ویدیویی کوتاه از طریق Sora API شرکت OpenAI. مناسب برای پلان‌های سینمایی، b-roll و تکرار سریع ویدیوهای مفهومی.',
    examplePrompt:
      'تولید، بازترکیب و مدیریت کلیپ‌های ویدیویی کوتاه از طریق Sora API شرکت OpenAI.',
  },
  'speech': {
    description:
      'تولید صدای گفتاری از متن با استفاده از API شرکت OpenAI همراه با صداهای داخلی. مناسب برای توضیح‌دهنده‌های روایت‌شده، صدای سخنرانی و تراک‌های صداگذاری سریع.',
    examplePrompt:
      'تولید صدای گفتاری از متن با استفاده از API شرکت OpenAI همراه با صداهای داخلی.',
  },
  'stitch-loop': {
    description:
      'حلقه بازخورد تکرارشونده طراحی به کد. چرخه نقد ← تنظیم ← ارائه برای بالا بردن وفاداری بصری میان بریف و UI ساخته‌شده.',
    examplePrompt:
      'حلقه بازخورد تکرارشونده طراحی به کد.',
  },
  'stitch-design-taste': {
    description:
      'اسکیل سیستم طراحی معنایی برای Google Stitch. فایل‌های DESIGN.md سازگار با ایجنت تولید می‌کند که استانداردهای UI پریمیوم و ضدکلیشه را اعمال می‌کنند — تایپوگرافی سخت‌گیرانه، رنگ کالیبره‌شده، چیدمان‌های نامتقارن، میکرو-موشن دائمی و عملکرد شتاب‌یافته با سخت‌افزار.',
    examplePrompt:
      'یک DESIGN.md سازگار با ایجنت برای این محصول با استانداردهای UI پریمیوم و ضدکلیشه، تایپوگرافی، رنگ، چیدمان، موشن و راهنمایی پرامپت تولید کن.',
  },
  'swiftui-design': {
    description:
      'اسکیل طراحی فرانت‌اند SwiftUI — قوانین ضد آشغال‌سازی هوش مصنوعی، مشاور جهت‌گیری طراحی، پروتکل دارایی‌های برند و بازبینی پنج‌بُعدی. با Claude Code، Cursor، Codex و OpenCode کار می‌کند.',
    examplePrompt:
      'اسکیل طراحی فرانت‌اند SwiftUI — قوانین ضد آشغال‌سازی هوش مصنوعی، مشاور جهت‌گیری طراحی، پروتکل دارایی‌های برند و بازبینی پنج‌بُعدی.',
  },
  'swiss-creative-mode-template': {
    description:
      'اسکیل قالب ارائه در حالت خلاقانه با الهام از سبک سوئیسی همراه با تایپوگرافی\nادیتوریال جسورانه، کارت‌های هندسی با کنتراست بالا، ناوبری تعاملی اسلایدها،\nتغییر تم، اوورلی‌های نقطه‌داغ (hotspot) و کوریوگرافی پالت در یک آرتیفکت\nHTML تک‌فایلی. زمانی استفاده کن که کاربران درخواست یک صفحه فرود به سبک ارائه پریمیوم،\nظاهر اسلاید سوئیسی/بروتالیست، یا یک صفحه لانچ خلاقانه با تعاملات غنی دارند.',
    examplePrompt:
      'اسکیل قالب ارائه در حالت خلاقانه با الهام از سبک سوئیسی همراه با تایپوگرافی ادیتوریال جسورانه، کارت‌های هندسی با کنتراست بالا، ناوبری تعاملی اسلایدها، تغییر تم، اوورلی‌های نقطه‌داغ (hotspot) و کوریوگرافی پالت در یک آرتیفکت HTML تک‌فایلی.',
  },
  'swiss-user-research-video-template': {
    description:
      'قالب روایت پژوهش کاربری به سبک سوئیسی با زیبایی‌شناسی ادیتوریال کاغذ گرم.\nزمانی استفاده کن که کاربران درخواست یک اسلاید پژوهشی پریمیوم یا آرتیفکت زنده داستان‌محور با\nتایپوگرافی مینیمال، چیدمان با وضوح بالا، حرکت ظریف، نمودارهای دونات\nو ناوبری با کیبورد/کلیک میان اسلایدها در یک فایل HTML واحد دارند.',
    examplePrompt:
      'یک اسلاید جمع‌بندی پژوهش کاربری به سبک سوئیسی با تایپوگرافی مینیمال پریمیوم، تن کاغذ گرم، نمودار دونات شرکت‌کنندگان و تعاملات ادیتوریال ظریف بساز.',
  },
  'design-taste-frontend': {
    description:
      'اسکیل فرانت‌اند ضد آشغال‌سازی برای صفحات فرود، نمونه‌کارها و بازطراحی‌ها. ایجنت بریف را می‌خواند، جهت‌گیری طراحی درست را استنتاج می‌کند و رابط‌هایی ارائه می‌دهد که قالبی به نظر نمی‌رسند. سیستم‌های طراحی واقعی در صورت کاربرد، حسابرسی‌محور در بازطراحی‌ها، بررسی سخت‌گیرانه پیش‌از‌اجرا.',
    examplePrompt:
      'یک صفحه فرود پریمیوم بساز که از design-taste-frontend پیروی کند: برداشت طراحی را استنتاج کن، تنظیمات را مشخص کن، از الگوهای آشغال‌سازی هوش مصنوعی پرهیز کن و یک آرتیفکت HTML واکنش‌گرا و صیقل‌خورده خروجی بده.',
  },
  'design-taste-frontend-v1': {
    description:
      'اسکیل اصلی نسخه v1 سلیقه طراحی، که برای پروژه‌های وابسته به رفتار دقیق آن حفظ شده است. پیش‌فرض فعلی `design-taste-frontend` (نسخه v2 آزمایشی) است که بازنویسی قابل‌توجهی محسوب می‌شود. این نام نصب v1 را فقط در صورتی استفاده کن که به سازگاری پسرو دقیق نیاز داری.',
    examplePrompt:
      'یک صفحه بازاریابی صیقل‌خورده با استفاده از design-taste-frontend-v1 همراه با تایپوگرافی قوی، فاصله‌گذاری، موشن و حفاظ‌های ضد آشغال‌سازی بساز.',
  },
  'theme-factory': {
    description:
      'اعمال تم‌های حرفه‌ای فونت و رنگ بر آرتیفکت‌ها از جمله اسلایدها، اسناد، گزارش‌ها و صفحات فرود HTML. شامل ۱۰ تم از پیش‌تنظیم‌شده.',
    examplePrompt:
      'اعمال تم‌های حرفه‌ای فونت و رنگ بر آرتیفکت‌ها از جمله اسلایدها، اسناد، گزارش‌ها و صفحات فرود HTML.',
  },
  'threejs': {
    description:
      'اسکیل‌های Three.js برای ساخت عناصر سه‌بعدی و تجربه‌های تعاملی در مرورگر — صحنه‌ها، متریال‌ها، کنترل‌ها و پس‌پردازش.',
    examplePrompt:
      'اسکیل‌های Three.js برای ساخت عناصر سه‌بعدی و تجربه‌های تعاملی در مرورگر — صحنه‌ها، متریال‌ها، کنترل‌ها و پس‌پردازش.',
  },
  'ui-skills': {
    description:
      'محدودیت‌های نظرمند و در حال تکامل برای هدایت ایجنت‌ها هنگام ساخت رابط‌ها. برای حفظ انسجام خروجی در میان قطعات کوچک متعدد UI مفید است.',
    examplePrompt:
      'محدودیت‌های نظرمند و در حال تکامل برای هدایت ایجنت‌ها هنگام ساخت رابط‌ها.',
  },
  'ui-ux-pro-max': {
    description:
      'ورودی فقط-کاتالوگ UI/UX Pro Max. قالب‌ها، داده‌ها و گردش‌کار جستجوی کامل بالادست در Open Design همراه نمی‌شود.',
    examplePrompt:
      'ورودی فقط-کاتالوگ UI/UX Pro Max.',
  },
  'venice-audio-music': {
    description:
      'نقاط پایانی صف‌بندی، بازیابی و تکمیل تولید موسیقی از طریق Venice.ai. مناسب برای جینگل‌ها، حلقه‌های پس‌زمینه و موسیقی‌گذاری نمونه اولیه.',
    examplePrompt:
      'نقاط پایانی صف‌بندی، بازیابی و تکمیل تولید موسیقی از طریق Venice.ai.',
  },
  'venice-audio-speech': {
    description:
      'مدل‌ها، صداها، فرمت‌ها و پخش جریانی تبدیل متن به گفتار از طریق Venice.ai. برای روایت، صداگذاری و صدای ایجنت‌های مکالمه‌ای مفید است.',
    examplePrompt:
      'مدل‌ها، صداها، فرمت‌ها و پخش جریانی تبدیل متن به گفتار از طریق Venice.ai.',
  },
  'venice-image-edit': {
    description:
      'ویرایش تصاویر، ارتقای کیفیت و حذف پس‌زمینه از طریق API Venice.ai.',
    examplePrompt:
      'ویرایش تصاویر، ارتقای کیفیت و حذف پس‌زمینه از طریق API Venice.ai.',
  },
  'venice-image-generate': {
    description:
      'نقاط پایانی تولید تصویر و سبک‌های در دسترس از طریق API Venice.ai.',
    examplePrompt:
      'نقاط پایانی تولید تصویر و سبک‌های در دسترس از طریق API Venice.ai.',
  },
  'venice-video': {
    description:
      'گردش‌کارهای تولید و رونویسی ویدیو از طریق API Venice.ai.',
    examplePrompt:
      'گردش‌کارهای تولید و رونویسی ویدیو از طریق API Venice.ai.',
  },
  'vfx-text-cursor': {
    description:
      'دنباله نوری نشانگر، پرتوهای رنگین و شراره‌های جهت‌دار برای نمایش کلمه‌به‌کلمه نقل‌قول‌ها در مقدمه‌های ویدیویی.',
    examplePrompt:
      'از قالب VFX Text Cursor برای تبدیل محتوای من به نمایش نقل‌قول در مقدمه ویدیو با دنباله‌های نوری نشانگر، پرتوهای رنگین و شراره‌های جهت‌دار استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'video-downloader': {
    description:
      'دانلود ویدیوها از YouTube و سایر پلتفرم‌ها برای تماشای آفلاین، ویرایش یا بایگانی با پشتیبانی از فرمت‌ها و گزینه‌های کیفیت گوناگون.',
    examplePrompt:
      'دانلود ویدیوها از YouTube و سایر پلتفرم‌ها برای تماشای آفلاین، ویرایش یا بایگانی با پشتیبانی از فرمت‌ها و گزینه‌های کیفیت گوناگون.',
  },
  'video-hyperframes': {
    description:
      'انیمیشن فریم پیوسته سازگار با HyperFrames / Remotion با پشتیبانی از پخش خودکار.',
    examplePrompt:
      'از قالب HyperFrames Video برای تبدیل محتوای من به یک انیمیشن فریم پیوسته سازگار با HyperFrames / Remotion با پشتیبانی از پخش خودکار استفاده کن. امضای بصری قالب را حفظ کن، از محتوا و داده‌های واقعی استفاده کن و از lorem ipsum یا تصاویر جایگزین پرهیز کن.',
  },
  'web-artifacts-builder': {
    description:
      'ساخت آرتیفکت‌های پیچیده HTML در claude.ai با React و Tailwind. گردش‌کار مرجع Anthropic برای عرضه آرتیفکت‌های غنی و قابل‌جاسازی.',
    examplePrompt:
      'ساخت آرتیفکت‌های پیچیده HTML در claude.ai با React و Tailwind.',
  },
  'web-design-guidelines': {
    description:
      'دستورالعمل‌ها و استانداردهای طراحی وب توسط تیم مهندسی Vercel. چیدمان، تایپوگرافی، رنگ، حرکت و دسترس‌پذیری را برای UI محصول پوشش می‌دهد.',
    examplePrompt:
      'دستورالعمل‌ها و استانداردهای طراحی وب توسط تیم مهندسی Vercel.',
  },
  'weread-year-in-review-video-template': {
    description:
      'قالب ویدیویی HyperFrames با الهام از WeRead برای گزارش‌های سالانه مطالعه عمودی،\nداشبوردهای شخصی مطالعه، جمع‌بندی یادداشت‌های کتاب و\nداستان‌های مرور پایان سال قابل اشتراک‌گذاری. زمانی استفاده شود که کاربران یک گزارش مطالعه HTML-به-MP4 با نسبت ۹:۱۶، بافت کاغذ گرم،\nتایپوگرافی ادبی چینی، استعاره‌های صفحه کتاب، برجسته‌سازی داده‌ها\nو حرکت قطعی می‌خواهند.',
    examplePrompt:
      'یک ویدیوی گزارش سالانه مطالعه HyperFrames به سبک WeRead با نسبت ۹:۱۶ شامل ۱۲ صحنه، بافت کاغذ گرم، گذارهای صفحه کتاب، آمار مطالعه، یادداشت‌ها، کلمات کلیدی و یک کارت شخصیت مطالعاتی پایانی بساز.',
  },
  'wpds': {
    description:
      'سیستم طراحی WordPress. توکن‌های طراحی رسمی، تایپوگرافی و الگوهای کامپوننت WordPress را به قالب‌ها و سایت‌ها اعمال کنید.',
    examplePrompt:
      'سیستم طراحی WordPress.',
  },
  'youtube-clipper': {
    description:
      'تولید و ویرایش کلیپ YouTube با گردش‌کارهای خودکار — دریافت ویدیوی منبع، برش لحظه‌های برجسته، افزودن زیرنویس و خروجی گرفتن.',
    examplePrompt:
      'تولید و ویرایش کلیپ YouTube با گردش‌کارهای خودکار — دریافت ویدیوی منبع، برش لحظه‌های برجسته، افزودن زیرنویس و خروجی گرفتن.',
  },
};

export const FA_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  'agentic': 'رابط مکالمه‌محور و هوش‌مصنوعی-اول با کنترل‌های حداقلی، نتایج روشن و جریان‌های وظیفه واگذارشده برای گردش‌کارهای ایجنتی.',
  'airbnb': 'مارکت‌پلیس سفر. تأکید مرجانی گرم، عکس‌محور، UI با گوشه‌های گرد.',
  'airtable': 'ترکیب صفحه‌گسترده و پایگاه‌داده. زیبایی‌شناسی داده‌ای رنگارنگ، صمیمی و ساختاریافته.',
  'ant': 'سیستم طراحی ساختاریافته و سازمان‌محور با تأکید بر وضوح، یکپارچگی و کارایی برای وب‌اپلیکیشن‌های پرداده.',
  'apple': 'الکترونیک مصرفی. فضای خالی پریمیوم، SF Pro، تصاویر سینمایی.',
  'application': 'داشبورد اپلیکیشن با زیبایی‌شناسی بنفش‌محور، ناوبری نوار بالا، چیدمان‌های کارت‌محور و گردش‌کارهای توسعه‌دهنده-اول.',
  'arc': '«مرورگری که به‌جای شما مرور می‌کند.» سطوح نیمه‌شفاف، گرمای گرادیانی، چیدمان نوار کناری-اول.',
  'artistic': 'سبک پرکنتراست و بیان‌گرا با تایپوگرافی خلاقانه و انتخاب‌های رنگی جسورانه برای رابط‌های بصری چشمگیر.',
  'atelier-zero': 'یک سیستم بصری مجله‌ای و کلاژمحور: بوم کاغذ گرم، تصاویر سوررئال\nگچ و معماری، تایپ نمایشی بسیار بزرگ، خطوط مویی،\nنشانگرهای بخش با اعداد رومی و حاشیه‌نویسی‌های ادبی کوچک.\nالهام‌گرفته از نسخه تولیدی v',
  'bento': 'چیدمان شبکه‌ای ماژولار با بلوک‌های کارت‌مانند، سلسله‌مراتب روشن، فاصله‌گذاری نرم و کنتراست بصری ظریف برای رابط‌های منظم و قابل‌مرور.',
  'binance': 'صرافی ارز دیجیتال. تأکید زرد پررنگ روی پس‌زمینه تک‌رنگ، با حس فوریت تالار معاملات.',
  'bmw': 'خودروی لوکس. سطوح تیره و پریمیوم، با زیبایی‌شناسی مهندسی دقیق آلمانی.',
  'bmw-m': 'زیربرند عملکردی ورزش‌های موتوری. سطوح کابین تقریباً مشکی، تأکیدهای سه‌رنگ BMW M، هندسه مهندسی تیز و دقیق.',
  'bold': 'حضور بصری قدرتمند با تایپوگرافی پروزن، رنگ‌های پرکنتراست و چیدمان‌های فرمانده.',
  'brutalism': 'زیبایی‌شناسی خام و ضدطراحی، الهام‌گرفته از معماری بتنی با عناصر بی‌پیرایه، چیدمان‌های خشن و مینیمالیسم کاربردی.',
  'bugatti': 'برند هایپرکار. بوم سینمایی مشکی، سادگی تک‌رنگ، تایپ نمایشی یادمانی.',
  'cafe': 'رابط کاربری دنج با الهام از کافه، با تن‌های گرم، تایپوگرافی نرم و چیدمان‌های تمیز برای تجربه مرور آرامش‌بخش.',
  'cal': 'زمان‌بندی متن‌باز. رابط کاربری تمیز و خنثی، با سادگی توسعه‌دهنده‌محور.',
  'canva': 'پلتفرم خلق بصری. گرادیان بنفش-آبی پرجلوه، فاصله‌گذاری سخاوتمندانه، هندسه صمیمی.',
  'cisco': 'برند زیرساخت سازمانی. سطوح تیره و قابل‌اعتماد، سیگنال آبی Cisco، شفافیت فنی.',
  'claude': 'دستیار هوش مصنوعی Anthropic. تأکید گرم تراکوتا، چیدمان تحریری تمیز.',
  'clay': 'آژانس خلاق. اشکال ارگانیک، گرادیان‌های نرم، چیدمان هنرمندانه.',
  'claymorphism': 'اشکال نرم و گرد شبه‌سه‌بعدی که گِل شکل‌پذیر را تقلید می‌کنند، با عناصر بازیگوش و پف‌کرده و سطوح رنگارنگ.',
  'clean': 'طراحی متمرکز بر سادگی با فضای خالی فراوان، تایپوگرافی خوانا و پالت رنگی محدود برای کاهش شلوغی بصری.',
  'clickhouse': 'پایگاه داده تحلیلی سریع. با تأکید زرد، به سبک مستندات فنی.',
  'cohere': 'پلتفرم هوش مصنوعی سازمانی. گرادیان‌های پرجنب‌وجوش، زیبایی‌شناسی داشبورد سرشار از داده.',
  'coinbase': 'صرافی ارز دیجیتال. هویت آبی تمیز، متمرکز بر اعتماد، با حس نهادی.',
  'colorful': 'پالت‌ها و گرادیان‌های پرجنب‌وجوش و پرکنتراست برای تجربه‌های کاربری جذاب، به‌یادماندنی و مدرن.',
  'composio': 'پلتفرم یکپارچه‌سازی ابزار. تیره مدرن با آیکون‌های یکپارچه‌سازی رنگارنگ.',
  'contemporary': 'طراحی مینیمال عصر حاضر با گریدهای بنتو، پشتیبانی از حالت تیره و چیدمان‌های پرکارایی و دردسترس.',
  'corporate': 'طراحی حرفه‌ای و هماهنگ با برند، با گریدهای ساختاریافته، چیدمان‌های مینیمال و الگوهای سازمانی یکپارچه.',
  'cosmic': 'زیبایی‌شناسی علمی-تخیلی آینده‌نگرانه با تم‌های تیره، تأکیدهای نئون پرجلوه و عناصر فضایی غوطه‌ورکننده.',
  'creative': 'طراحی بازیگوش و شخصیت‌محور با تایپوگرافی گویا و گرافیک‌های پررنگ برای صفحات فرود و پروژه‌های خلاقانه.',
  'cursor': 'ویرایشگر کد هوش مصنوعی‌محور. رابط تیره و شیک، با تأکیدهای گرادیانی.',
  'dashboard': 'زیبایی‌شناسی پلتفرم ابری با تم تیره، با گریدهای ماژولار، پنل‌های شیشه‌ای و سلسله‌مراتب قوی داده برای داشبوردهای بهره‌وری.',
  'default': 'یک پیش‌فرض تمیز و محصول‌محور برای ابزارهای B2B، داشبوردها و صفحات کاربردی.',
  'discord': 'پلتفرم صوت / گفتگو. بنفش-آبی عمیق، سطوح با اولویت تیره، لحظات تأکید بازیگوش.',
  'dithered': 'تکنیک رندر الگوی نقطه‌ای که سایه‌ها را با پالت محدود شبیه‌سازی می‌کند، برای تصاویر نوستالژیک، رترو و پرکنتراست.',
  'doodle': 'سبک دست‌کشیده و شبه‌اسکچ با دودل‌ها، فونت‌های دست‌نویس و خطوط ناکامل برای حسی بازیگوش و غیررسمی.',
  'dramatic': 'طراحی پرکنتراست و نمایشی با چیدمان‌های پررنگ، تصاویر غوطه‌ورکننده و ترکیب‌بندی‌های نامتعارف که توجه را به خود جلب می‌کنند.',
  'duolingo': 'پلتفرم آموزش زبان. سبز جغد روشن، سایه‌های ضخیم، شادی گیمیفای‌شده.',
  'editorial': 'چیدمان تحریری با الهام از مجله، با تایپوگرافی سریف ظریف، گریدهای ساختاریافته و تجربه‌های مطالعه شیک.',
  'elegant': 'زیبایی‌شناسی برازنده و ظریف با تایپوگرافی لطیف، پالت‌های مینیمال و چیدمان‌های پرداخت‌شده که ظرافت را به نمایش می‌گذارند.',
  'elevenlabs': 'پلتفرم صوتی هوش مصنوعی. رابط سینمایی تیره، زیبایی‌شناسی موج صوتی.',
  'energetic': 'سبک پویا و پرجنب‌وجوش با حاشیه‌های ضخیم، اشکال هندسی، رنگ‌های پرکنتراست و تایپوگرافی گویا که حرکت و سرزندگی را منتقل می‌کند.',
  'enterprise': 'طراحی سازمانی تمیز و پرکنتراست برای جریان‌های کاری داده‌محور، با الگوهای کشیدن‌ورهاکردن شهودی و چیدمان‌های ساختاریافته.',
  'expo': 'پلتفرم React Native. تم تیره، فاصله‌گذاری فشرده حروف، کدمحور.',
  'expressive': 'طراحی پرجنب‌وجوش و شخصیت‌محور با رنگ‌های پررنگ، گرافیک‌های بازیگوش و چیدمان‌های پویا که خلاقیت را با ساختار متعادل می‌کند.',
  'fantasy': 'زیبایی‌شناسی فانتزی با الهام از بازی، با تصاویر پررنگ و پریمیوم، پالت‌های رنگی غنی و عناصر تماتیک غوطه‌ورکننده.',
  'ferrari': 'خودروی لوکس. سبک تحریری کیاروسکورو، تأکیدهای قرمز Ferrari، مشکی سینمایی.',
  'figma': 'ابزار طراحی مشارکتی. چندرنگ پرجنب‌وجوش، بازیگوش اما حرفه‌ای.',
  'flat': 'سبک مینیمال دوبعدی با رنگ‌های پرجنب‌وجوش، تایپوگرافی تمیز و بدون افکت‌های سه‌بعدی برای رابط‌های سریع و کاربرپسند.',
  'framer': 'سازنده وب‌سایت. مشکی و آبی پررنگ، حرکت‌محور، طراحی‌محور.',
  'friendly': 'طراحی دلپذیر و شهودی با عناصر گرد، فضای خالی فراوان و پالت رنگ‌های پاستلی ملایم.',
  'futuristic': 'طراحی آینده‌نگر با تایپوگرافی الهام‌گرفته از فناوری، چیدمان‌های مدرن و زیبایی‌شناسی شیک و نوآوری‌محور.',
  'github': 'پلتفرم کدمحور. تراکم کارکردی، دقت آبی‌روی‌سفید، بنیان‌های Primer.',
  'glassmorphism': 'افکت شیشه مات با لایه‌های نیمه‌شفاف، محو ظریف و حاشیه‌های درخشان برای عمق و ظرافت مدرن.',
  'gradient': 'گذارهای رنگی نرم و سطوح سرشار از گرادیان برای رابط‌های مدرن و بازیگوش با عمق بصری.',
  'hashicorp': 'خودکارسازی زیرساخت. تمیز و سازمانی، مشکی و سفید.',
  'hud': 'نمایشگر بالای سر جنگنده / هلیکوپتر. سبز فسفری روی پس‌زمینه تقریباً مشکی، روپوش‌های داده تمام‌بزرگ، هندسه زاویه‌دار. ابهام صفر در سرعت و ارتفاع.',
  'huggingface': 'مرکز جامعه یادگیری ماشین. تأکید زرد آفتابی، هویت مونواسپیس، شاد و متراکم.',
  'ibm': 'فناوری سازمانی. سیستم طراحی Carbon، پالت آبی ساختاریافته.',
  'intercom': 'پیام‌رسانی مشتری. پالت آبی دوستانه، الگوهای رابط کاربری مکالمه‌ای.',
  'kami': 'سیستم کاغذی تحریری: بوم پارچمنت گرم، تأکید آبی‌جوهری، سلسله‌مراتب سریف‌محور. ساخته‌شده برای رزومه‌ها، تک‌برگی‌ها، وایت‌پیپرها، نمونه‌کارها، اسلایدها — هر چیزی که باید حس چاپ باکیفیت بدهد نه رابط کاربری. چندزبانه به‌صورت پیش‌فرض',
  'kraken': 'معاملات کریپتو. رابط تیره با تأکید بنفش، داشبوردهای پرتراکم داده.',
  'lamborghini': 'برند خودروی سوپراسپرت. سطوح مشکی واقعی، تأکیدهای طلایی، تایپوگرافی بزرگ و دراماتیک.',
  'levels': 'طراحی تبدیل‌محور که اصطکاک را حذف می‌کند و کاربران را از طریق وضوح، اعتماد و سرعت به‌سوی عمل هدایت می‌کند.',
  'linear-app': 'مدیریت پروژه. فوق‌مینیمال، دقیق، تأکید بنفش.',
  'lingo': 'طراحی بازیگوش و مینیمال با رنگ‌های روشن، اشکال گرد، حاشیه‌های سه‌بعدی لمسی و تصویرسازی‌های دوستانه برای رابط‌های دلپذیر.',
  'loom': 'ویدیوی غیرهمزمان Loom. بنفش اصلی، سطوح دوستانه، چیدمان ویدیومحور. تمیز و حرفه‌ای بدون اینکه شرکتی به نظر برسد.',
  'lovable': 'سازنده فول‌استک هوش مصنوعی. گرادیان‌های بازیگوش، زیبایی‌شناسی توسعه‌دهنده‌پسند و دوستانه.',
  'luxury': 'زیبایی‌شناسی تیره سطح‌بالا با تیترهای پررنگ، پالت تک‌رنگ و حس لاکچری برای تجربه‌های برند لوکس.',
  'mastercard': 'شبکه پرداخت جهانی. بوم کرمی گرم، اشکال قرص‌مانند مداری، گرمای تحریری.',
  'material': 'Material Design گوگل با سطوح لایه‌لایه، تم‌بندی پویا، حرکت داخلی و الگوهای واکنش‌گرای چندپلتفرمی.',
  'meta': 'فروشگاه خرده‌فروشی فناوری. عکاسی‌محور، سطوح دوگانه روشن/تیره، دکمه‌های فراخوان به اقدام با رنگ Meta Blue.',
  'minimal': 'طراحی ساده‌شده با تأکید بر فضای خالی، تایپوگرافی تمیز و رنگ محدود برای حداکثر وضوح و تمرکز.',
  'minimax': 'ارائه‌دهنده مدل هوش مصنوعی. رابط تیره پررنگ با تأکیدهای نئونی.',
  'mintlify': 'پلتفرم مستندسازی. تمیز، با تأکید سبز، بهینه‌شده برای مطالعه.',
  'miro': 'همکاری بصری. تأکید زرد روشن، زیبایی‌شناسی بوم بی‌نهایت.',
  'mission-control': 'پایش مأموریت فضایی/هوافضا. مرکز فرماندهی تیره، تله‌متری کهربایی، دقت مونواسپیس. وضوح کارکردی بالاتر از هر چیز دیگر.',
  'mistral-ai': 'ارائه‌دهنده مدل زبانی بزرگ با وزن‌های باز. مینیمالیسم با مهندسی فرانسوی، با ته‌رنگ بنفش.',
  'modern': 'سبک تحریری معاصر با تایپوگرافی سریف، پالت‌های مینیمال و چیدمان‌های تمیز برای محصولات دیجیتال صیقلی.',
  'mongodb': 'پایگاه‌داده اسناد. برندینگ برگ سبز، تمرکز بر مستندات توسعه‌دهنده.',
  'mono': 'طراحی مونواسپیس‌محور و الهام‌گرفته از ماتریکس با عناصر کنتراست‌بالا، تراکم فشرده و زیبایی‌شناسی شیک هکری.',
  'neobrutalism': 'برداشتی مدرن از بروتالیسم با حاشیه‌های پررنگ، رنگ‌های تأکیدی زنده و چیدمان‌های خام و کنتراست‌بالا روی سطوح گرم.',
  'neon': 'افکت‌های درخشش نئونی الکتریکی با جفت‌رنگ‌های کنتراست‌بالا برای رابط‌های پررنگ و توجه‌برانگیز.',
  'neumorphism': 'عناصر رابط کاربری نرم و برجسته با سایه‌های درونی و بیرونی روی سطوح تک‌رنگ برای ظاهری لمسی و فرورفته.',
  'nike': 'خرده‌فروشی ورزشی. رابط تک‌رنگ، تایپ بزرگ و تمام‌بزرگ، عکاسی تمام‌صفحه.',
  'notion': 'فضای کاری همه‌کاره. مینیمالیسم گرم، تیترهای سریف، سطوح ملایم.',
  'nvidia': 'محاسبات GPU. انرژی سبز-مشکی، زیبایی‌شناسی قدرت فنی.',
  'ollama': 'اجرای محلی LLMها. ترمینال‌محور، با سادگی تک‌رنگ.',
  'openai': 'سیستمی آرام و تقریباً تک‌رنگ که بر پایه‌ی سبز-آبی تیره و سیاه بنا شده، با فضای سفید فراوان و تایپوگرافی تحریری.',
  'opencode-ai': 'پلتفرم کدنویسی هوش مصنوعی. تم تیره با تمرکز بر توسعه‌دهنده.',
  'pacman': 'طراحی الهام‌گرفته از آرکیدهای رترو با فونت‌های پیکسلی، حاشیه‌های نقطه‌چین، رنگ‌های بازیگوش و پرکنتراست، و زیبایی‌شناسی بازی‌های ۸ بیتی.',
  'paper': 'طراحی الهام‌گرفته از چاپ با بافت کاغذی، رنگ‌های کم، تایپوگرافی تمیز سریف/سنس، و کیفیت سطحی لمسی.',
  'perplexity': 'موتور جست‌وجوی هوش مصنوعی گفت‌وگومحور. بوم تیره‌ی عمیق، تایپوگرافی شارپ، یک رنگ تأکیدی بنفش، و سلسله‌مراتب اطلاعاتی متراکم.',
  'perspective': 'طراحی با عمق فضایی همراه با نماهای ایزومتریک، نقاط گریز، و عناصر لایه‌لایه که توجه را از طریق واقع‌گرایی سه‌بعدی‌گونه هدایت می‌کنند.',
  'pinterest': 'کشف بصری. رنگ تأکیدی قرمز، شبکه‌ی آجری (masonry)، تصویرمحور.',
  'playstation': 'خرده‌فروشی کنسول‌های بازی. چیدمان کانالی سه‌سطحی، تایپ نمایشی با اقتدار آرام، بزرگ‌نمایی فیروزه‌ای هنگام هاور.',
  'posthog': 'تحلیل محصول. برندینگ بازیگوش با خارپشت، رابط کاربری تیره و دوست‌دار توسعه‌دهنده.',
  'premium': 'زیبایی‌شناسی پریمیوم الهام‌گرفته از Apple با فاصله‌گذاری دقیق، تایپوگرافی مدرن، و زبان بصری ظریف و صیقلی.',
  'professional': 'طراحی صیقلی و آماده برای کسب‌وکار با تایپوگرافی مدرن، چیدمان‌های ساختارمند، و هویت بصری قابل‌اعتماد.',
  'publication': 'زبان بصری الهام‌گرفته از چاپ برای کتاب‌ها، مجلات و گزارش‌ها با شبکه‌های تحریری و تایپوگرافی بیانگر.',
  'raycast': 'لانچر بهره‌وری. کروم تیره‌ی شیک، رنگ‌های تأکیدی گرادیانی پرجنب‌وجوش.',
  'refined': 'سبک مینیمال مدرن و با دقت گزیده‌شده با تایپوگرافی سریف زیبا و پالت‌های ملایم و پیچیده.',
  'renault': 'خودروسازی فرانسوی. گرادیان‌های شفق پرجنب‌وجوش، تایپوگرافی NouvelR، انرژی جسورانه.',
  'replicate': 'اجرای مدل‌های ML از طریق API. بوم سفید تمیز، کدمحور.',
  'resend': 'API ایمیل. تم تیره‌ی مینیمال، تأکیدهای مونواسپیس.',
  'retro': 'طراحی بازگشت به گذشته با تایپوگرافی الهام‌گرفته از سبک قدیمی، پالت‌های رترو پرکنتراست، و عناصر بصری نوستالژیک.',
  'revolut': 'بانکداری دیجیتال. رابط تیره‌ی شیک، کارت‌های گرادیانی، دقت فین‌تک.',
  'runwayml': 'تولید ویدیوی هوش مصنوعی. رابط کاربری تیره‌ی سینمایی، چیدمان غنی از رسانه.',
  'sanity': 'CMS هدلس. رنگ تأکیدی قرمز، چیدمان تحریری محتوامحور.',
  'sentry': 'پایش خطا. داشبورد تیره، داده‌متراکم، رنگ تأکیدی صورتی-بنفش.',
  'shadcn': 'طراحی الهام‌گرفته از Shadcn/ui با کامپوننت‌های مینیمال و تمیز، پالت تک‌رنگ، و الگوهای utility-first.',
  'shopify': 'پلتفرم تجارت الکترونیک. سینمایی و تیره‌محور، رنگ تأکیدی سبز نئون، تایپ بسیار نازک.',
  'simple': 'طراحی سرراست و بدون پیرایه با تایپوگرافی تمیز، رنگ‌های خنثی، و چیدمان‌های شهودی که سر راه قرار نمی‌گیرند.',
  'skeumorphism': 'تقلید از دنیای واقعی با سطوح بافت‌دار، جلوه‌های سه‌بعدی، و استعاره‌های فیزیکی آشنا برای رابط‌های دیجیتال شهودی.',
  'slack': 'پلتفرم ارتباطات محل کار. رنگ اصلی بادمجانی، پالت لوگوی چندرنگ تأکیدی، سطوح روشن با نوار کناری تیره، گرم و دوستانه.',
  'sleek': 'زیبایی‌شناسی مینیمالیست مدرن با خطوط تمیز، پالت رنگ هدفمند، تعاملات ظریف، و فاصله‌گذاری یکدست.',
  'spacex': 'فناوری فضایی. سیاه و سفید خالص، تصاویر تمام‌قاب، آینده‌نگرانه.',
  'spacious': 'فضای سفید فراوان، پدینگ یکدست، و چیدمان‌های مبتنی بر شبکه برای رابط‌هایی تمیز، خوانا و نفس‌کش.',
  'spotify': 'پخش موسیقی. سبز پرجنب‌وجوش روی پس‌زمینه‌ی تیره، تایپ جسورانه، کاورِ آلبوم‌محور.',
  'starbucks': 'برند جهانی خرده‌فروشی قهوه. سیستم سبز چهارلایه، بوم کرمی گرم، دکمه‌های کاملاً قرص‌شکل.',
  'storytelling': 'طراحی روایت‌محور با بهره‌گیری از تصاویر، متن و تعامل برای هدایت کاربران در سفرهای جذاب و احساسی.',
  'stripe': 'زیرساخت پرداخت. گرادیان‌های بنفش امضایی، ظرافت با وزن ۳۰۰.',
  'supabase': 'جایگزین متن‌باز Firebase. تم زمردی تیره، کدمحور.',
  'superhuman': 'کلاینت ایمیل سریع. رابط کاربری تیره‌ی پریمیوم، کیبوردمحور، درخشش بنفش.',
  'tesla': 'خودروسازی برقی. کاهش رادیکال، عکاسی تمام‌صفحه، رابط کاربری نزدیک به صفر.',
  'tetris': 'طراحی کلاسیک الهام‌گرفته از بازی بلوکی با رنگ‌های بازیگوش، فونت‌های نمایشی جسورانه، و چیدمان‌های فشرده و پرانرژی.',
  'theverge': 'رسانه‌ی تحریری فناوری. رنگ‌های تأکیدی نعنایی تند و فرابنفش، تایپ نمایشی Manuka، کاشی‌های داستانی به سبک تراکت ریو.',
  'together-ai': 'زیرساخت هوش مصنوعی متن‌باز. طراحی فنی و نقشه‌وار.',
  'totality-festival': 'یک سیستم تیره شیشه‌ای و کیهانی-لاکچری که حس عمیق و غریزی شکوه یک خورشیدگرفتگی را به تصویر می‌کشد — سطوح اُبسیدینی، هایلایت‌های کهربایی «تاج خورشید» و لهجه‌های اتمسفری فیروزه‌ای.',
  'trading-terminal': 'ترمینال معاملاتی مالی به سبک Bloomberg. فقط حالت تیره، متراکم از داده، سیگنال‌های خرید/فروش فیروزه‌ای/مرجانی. همه‌چیز از فاصله دو متری در یک نگاه خوانا.',
  'uber': 'پلتفرم حمل‌ونقل. سیاه و سفید جسورانه، تایپوگرافی فشرده، انرژی شهری.',
  'urdu': 'تجربه‌های دیجیتال اردو-محور با پشتیبانی بومی RTL، تایپوگرافی نستعلیق و هماهنگی دوزبانه.',
  'vercel': 'استقرار فرانت‌اند. دقت سیاه و سفید، فونت Geist.',
  'vibrant': 'طراحی سرزنده و رنگارنگ با تایپوگرافی جسورانه و بازیگوش، لهجه‌های گرم و انرژی بصری پویا.',
  'vintage': 'نوستالژی دهه‌های ۱۹۵۰ تا ۱۹۹۰ با جزئیات اسکئومورفیک، بافت‌های دانه‌دار، پالت‌های رنگی رترو و تایپوگرافی پیکسلی.',
  'vodafone': 'برند مخابراتی جهانی. نمایش حروف بزرگ یادمانی، نوارهای فصلی Vodafone Red.',
  'voltagent': 'چارچوب عامل هوش مصنوعی. بوم سیاه مطلق، لهجه زمردی، بومیِ ترمینال.',
  'warm-editorial': 'زیبایی‌شناسی مجله‌ای با محوریت فونت سریف. لهجه تراکوتا روی کاغذ گرم شکسته‌سفید —\nمناسب برای محتوای بلند، تحریریه‌ای و صفحات بازاریابی برندمحور.',
  'warp': 'ترمینال مدرن. رابط تیره شبیه IDE، رابط فرمان مبتنی بر بلوک.',
  'webex': 'پلتفرم همکاری. تایپوگرافی پرشتاب، سیستم کنشِ آبی، طیف لهجه چندکاربره.',
  'webflow': 'سازنده بصری وب. زیبایی‌شناسی صیقلیِ سایت بازاریابی با لهجه آبی.',
  'wechat': 'زبان بصری برند برای مینی‌پروگرام‌های WeChat، اکانت‌های رسمی و افزونه‌های اکوسیستم باز.',
  'wired': 'مجله فناوری. تراکم روزنامه‌ای کاغذ-سفید، نمایش سریف سفارشی، کیکرهای مونو، لینک‌های آبی-جوهری.',
  'wise': 'انتقال پول. لهجه سبز روشن، دوستانه و شفاف.',
  'x-ai': 'آزمایشگاه هوش مصنوعی ایلان ماسک. تک‌رنگ صریح، مینیمالیسم آینده‌نگرانه.',
  'xiaohongshu': 'پلتفرم اجتماعی محتوای کاربرساز سبک زندگی. قرمز برند منفرد، گردیِ سخاوتمندانه، محتوا-محور.',
  'zapier': 'پلتفرم اتوماسیون. نارنجی گرم، دوستانه و مبتنی بر تصویرسازی.',
};

export const FA_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  'AI & LLM': 'هوش مصنوعی و LLM',
  'Automotive': 'خودرو',
  'Backend & Data': 'بک‌اند و داده',
  'Bold & Expressive': 'جسور و بیانگر',
  'Creative & Artistic': 'خلاقانه و هنری',
  'Design & Creative': 'طراحی و خلاقیت',
  'Developer Tools': 'ابزارهای توسعه‌دهنده',
  'E-Commerce & Retail': 'تجارت الکترونیک و خرده‌فروشی',
  'Editorial & Print': 'تحریریه و چاپ',
  'Editorial / Personal / Publication': 'تحریریه / شخصی / نشریه',
  'Editorial · Studio': 'تحریریه · استودیو',
  'Fintech & Crypto': 'فین‌تک و کریپتو',
  'Layout & Structure': 'چیدمان و ساختار',
  'Media & Consumer': 'رسانه و مصرف‌کننده',
  'Modern & Minimal': 'مدرن و مینیمال',
  'Morphism & Effects': 'مورفیسم و افکت‌ها',
  'Productivity & SaaS': 'بهره‌وری و SaaS',
  'Professional & Corporate': 'حرفه‌ای و سازمانی',
  'Retro & Nostalgic': 'رترو و نوستالژیک',
  'Social & Messaging': 'اجتماعی و پیام‌رسانی',
  'Starter': 'شروع‌کننده',
  'Themed & Unique': 'تماتیک و منحصربه‌فرد',
};

export const FA_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  'Advertising': 'تبلیغات',
  'Anime': 'انیمه',
  'Anime / Manga': 'انیمه / مانگا',
  'App / Web Design': 'طراحی اپلیکیشن / وب',
  'Branding': 'برندسازی',
  'Cinematic': 'سینمایی',
  'Data': 'داده',
  'Game UI': 'رابط کاربری بازی',
  'General': 'عمومی',
  'Illustration': 'تصویرسازی',
  'Infographic': 'اینفوگرافیک',
  'Live Artifact': 'آرتیفکت زنده',
  'Marketing': 'بازاریابی',
  'Motion Graphics': 'موشن گرافیک',
  'Product': 'محصول',
  'Profile / Avatar': 'پروفایل / آواتار',
  'Short Form': 'فرم کوتاه',
  'Social / Meme': 'اجتماعی / میم',
  'Social Media Post': 'پست شبکه اجتماعی',
  'Travel': 'سفر',
  'VFX / Fantasy': 'جلوه‌های ویژه / فانتزی',
  'VFX / HTML-in-Canvas': 'جلوه‌های ویژه / HTML در بوم',
};

export const FA_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': 'سه‌بعدی',
  '3d-render': 'رندر سه‌بعدی',
  'action': 'اکشن',
  'ancient-china': 'چین باستان',
  'anime': 'انیمه',
  'app-showcase': 'نمایش اپلیکیشن',
  'archery': 'تیراندازی با کمان',
  'arpg': 'arpg',
  'audio-reactive': 'واکنش‌گرا به صدا',
  'boss-fight': 'نبرد با باس',
  'brand': 'برند',
  'branding': 'برندسازی',
  'captions': 'زیرنویس‌ها',
  'cavalry': 'سواره‌نظام',
  'chart': 'نمودار',
  'childlike': 'کودکانه',
  'choreography': 'طراحی حرکت',
  'cinematic': 'سینمایی',
  'cinematic-romance': 'عاشقانه سینمایی',
  'combat': 'مبارزه',
  'combo': 'کمبو',
  'companion-to-image': 'همراه به تصویر',
  'counter': 'شمارنده',
  'crayon': 'مداد شمعی',
  'cyberpunk': 'سایبرپانک',
  'dance': 'رقص',
  'dashboard': 'داشبورد',
  'data': 'داده',
  'data-viz': 'مصورسازی داده',
  'destruction': 'تخریب',
  'displacement': 'جابجایی',
  'editorial': 'تحریریه',
  'elden-ring': 'Elden Ring',
  'endcard': 'کارت پایانی',
  'escort': 'اسکورت',
  'escort-mission': 'مأموریت اسکورت',
  'fantasy': 'فانتزی',
  'fashion': 'مد',
  'fighting-game': 'بازی مبارزه‌ای',
  'food': 'غذا',
  'game-cinematic': 'سینمایی بازی',
  'game-ui': 'رابط کاربری بازی',
  'grid-sheet': 'برگه شبکه‌ای',
  'guanyu': 'گوان‌یو',
  'hand-drawn': 'دست‌نویس',
  'hero': 'قهرمان',
  'html-in-canvas': 'HTML در بوم',
  'hud': 'HUD',
  'hud-safe': 'محدوده امن HUD',
  'hype': 'هیجان',
  'hyperframes': 'HyperFrames',
  'idol': 'آیدل',
  'illustration': 'تصویرسازی',
  'image-to-image': 'تصویر به تصویر',
  'infographic': 'اینفوگرافیک',
  'iphone': 'iPhone',
  'japanese': 'ژاپنی',
  'karaoke': 'کارائوکه',
  'key-visual': 'تصویر کلیدی',
  'keynote': 'سخنرانی کلیدی',
  'kinetic-typography': 'تایپوگرافی متحرک',
  'linear-style': 'سبک Linear',
  'liquid': 'مایع',
  'liquid-glass': 'شیشه مایع',
  'live-artifact': 'آرتیفکت زنده',
  'logo': 'لوگو',
  'lyubu': 'lyubu',
  'macbook': 'مک‌بوک',
  'magnetic': 'مغناطیسی',
  'map': 'نقشه',
  'marketing': 'بازاریابی',
  'minimal': 'مینیمال',
  'mmo': 'MMO',
  'mobile': 'موبایل',
  'money': 'پول',
  'mounted-combat': 'نبرد سواره',
  'nature': 'طبیعت',
  'open-world': 'جهان باز',
  'otaku-dance': 'رقص اوتاکو',
  'outro': 'پایان‌بندی',
  'overlay': 'روکش',
  'particles': 'ذرات',
  'pipeline': 'خط لوله',
  'portal': 'پرتال',
  'portrait': 'پرتره',
  'pose-reference': 'مرجع ژست',
  'product': 'محصول',
  'product-demo': 'دموی محصول',
  'product-promo': 'تبلیغ محصول',
  'rework': 'بازسازی',
  'route': 'مسیر',
  'saas': 'SaaS',
  'sequence': 'توالی',
  'shader': 'شیدر',
  'shatter': 'خردشدن',
  'sizzle': 'تیزر',
  'social': 'اجتماعی',
  'storyboard': 'استوری‌بورد',
  'street-fighter': 'street-fighter',
  'style-transfer': 'انتقال سبک',
  'tekken': 'tekken',
  'text': 'متن',
  'three-kingdoms': 'سه پادشاهی',
  'tiktok': 'tiktok',
  'title-card': 'کارت عنوان',
  'transform': 'تبدیل',
  'travel': 'سفر',
  'tts': 'tts',
  'typography': 'تایپوگرافی',
  'unreal-engine-5': 'unreal-engine-5',
  'vertical': 'عمودی',
  'video-reference': 'مرجع ویدیویی',
  'vs-screen': 'صفحه رویارویی',
  'webgl': 'webgl',
  'website-to-video': 'وب‌سایت به ویدیو',
  'wuxia': 'ووشیا',
  'zhaoyun': 'zhaoyun',
};

export const FA_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: 'اینفوگرافیک سه‌بعدی تکامل با پلکان سنگی',
    summary:
      'یک خط زمانی تکاملی مسطح را به یک اینفوگرافیک سه‌بعدی واقع‌گرایانه با پلکان سنگی تبدیل می‌کند که شامل رندرهای دقیق موجودات و پنل‌های جانبی ساختاریافته است.',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'تصویرسازی نبرد رزمی به سبک انیمه',
    summary:
      'یک تصویرسازی پویا و پرتأثیر به سبک انیمه تولید می‌کند که دو شخصیت زن را در حال مبارزه در یک دوجوی سنتی همراه با جلوه‌های انرژی عناصر نشان می‌دهد.',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'ماکاپ رابط کاربری پخش زنده تجارت الکترونیک',
    summary:
      'یک رابط کاربری واقع‌گرایانه پخش زنده شبکه اجتماعی تولید می‌کند که روی یک پرتره قرار می‌گیرد و شامل پیام‌های چت قابل سفارشی‌سازی، پاپ‌آپ‌های هدیه و یک کارت خرید محصول است.',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {
    title: 'اسکرین‌شات بازی - بازی مبارزه‌ای انیمه: Captain Ryuuga در برابر Kaze Renshin',
    summary:
      'یک کی‌ویژوال/اسکرین‌شات مبارزه درون‌بازی به سبک هنر مقدماتی Street Fighter 6 یا Tekken 8. دو جنگجوی مرد به سبک انیمه در مرکز یک حیاط معبد چینی دراماتیک در شب رو در روی هم قرار می‌گیرند — یک دزد دریایی با کلاه حصیری و بالاتنه برهنه با هاله آتشین نارنجی-قرمز گرم در سمت چپ، و یک هنرمند رزمی با موهای تیز در یک گی نارنجی که در حال شارژ یک کره عظیم انرژی صاعقه آبی پرنوسان در سمت راست است. به همراه یک HUD کامل بازی مبارزه‌ای (نوارهای سلامت دوگانه، تایمر دور، پنل‌های پرتره P1/P2 با نام مبارزان و نشان‌ها، شمارنده‌های کمبو و گیج‌های حداکثر برای هر طرف). درجه‌بندی رنگ تقسیم‌شده نارنجی گرم در برابر آبی سرد با قرارداد مبارزان رقیب این ژانر هماهنگ است. تنظیم‌شده برای gpt-image-2 با نسبت 16:9.',
  },
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'اسکرین‌شات بازی - ARPG سه پادشاهی: Guan Yu در حال کشتن Yan Liang',
    summary:
      'یک اسکرین‌شات بازی نقش‌آفرینی اکشن درون‌بازی از صحنه نمادین سه پادشاهی که در آن Guan Yu سوار بر اسب جنگی Red Hare خود از میان میدان نبرد بارانی شدید می‌تازد و به سوی ژنرال دشمن Yan Liang هجوم می‌برد. رندرشده به سبک سینمایی فوتورئال Black Myth: Wukong، Unreal Engine 5، دوربین تعقیب سوم‌شخص از پشت و سمت چپ قهرمان سوار. یک HUD کامل نبرد باس (پرتره، مینی‌مپ با نقاط متراکم دشمن، نوار میانبر مهارت با اعلان ضربه نهایی، نوار شناور HP باس روی ژنرال دشمن) صحنه را به یک لحظه مبارزه ARPG رده AAA تبدیل می‌کند. تنظیم‌شده برای gpt-image-2 با نسبت 16:9.',
  },
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'اسکرین‌شات بازی - ARPG سه پادشاهی: تیراندازی Yuanmen توسط Lü Bu',
    summary:
      'یک اسکرین‌شات بازی نقش‌آفرینی اکشن درون‌بازی از صحنه مشهور سه پادشاهی که در آن Lü Bu یک نیزه دوسر دوردست را در دروازه اردوگاه با تیر می‌زند تا یک نبرد را متوقف کند. رندرشده به سبک سینمایی فوتورئال Black Myth: Wukong، Unreal Engine 5 با Nanite/Lumen، دوربین گیم‌پلی سوم‌شخص از روی شانه. یک پوشش HUD کامل درون‌بازی (نوارهای HP و چی، مینی‌مپ، نوار میانبر مهارت، نشانگر قفل هدف با نمایش فاصله تا نیزه دوسر دوردست) باعث می‌شود این تصویر به جای یک میان‌پرده، یک ضبط واقعی ARPG نسل بعد به نظر برسد. تنظیم‌شده برای gpt-image-2 با نسبت 16:9.',
  },
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'اسکرین‌شات بازی - ARPG سه پادشاهی: فرار Zhao Yun با نوزاد در آغوش در Changbanpo',
    summary:
      'یک اسکرین‌شات بازی نقش‌آفرینی اکشن درون‌بازی از صحنه افسانه‌ای سه پادشاهی که در آن Zhao Yun نوزاد Liu Chan را با یک دست در آغوش می‌گیرد و با دست دیگر با یک نیزه از میان خطوط دشمن در Changbanpo راه خود را با جنگیدن باز می‌کند. رندرشده به سبک سینمایی فوتورئال Black Myth: Wukong ترکیب‌شده با Elden Ring، Unreal Engine 5 با Nanite کامل، ردیابی پرتو Lumen و پرتوهای حجمی نور خدا. هسته احساسی — یک دست در حال محافظت از نوزاد قنداق‌شده، یک دست در حال جنگ برای زندگی — با یک پوشش HUD کامل شامل یک نوار محافظت ESCORT اختصاصی برای نوزاد، یک شمارنده کمبو و پاپ‌آپ‌های عدد آسیب در هوا روی دشمنان پرتاب‌شده تقویت شده است. تنظیم‌شده برای gpt-image-2 با نسبت 16:9.',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'رابط کاربری بازی - HUD بازی MMO جهان‌باز چین باستان',
    summary:
      'یک ماکاپ اسکرین‌شات HUD درون‌بازی برای یک MMO جهان‌باز چین باستان رده AAA به سبک سینمایی فوتورئال Black Myth: Wukong تولید می‌کند. یک قهرمان شمشیرزن زن زیبا مرکز قاب را در یک صحنه زیارتگاه باستانی کوهستانی مه‌آلود تثبیت می‌کند و توسط یک HUD کامل MMO احاطه شده است: پرتره شخصیت در بالا-چپ با نوارهای HP/MP/استقامت و آیکون‌های بافت، نوار میانبر مهارت در پایین-مرکز با آیکون‌های مهارت خوشنویسی چینی، مینی‌مپ در بالا-راست با نشانگرهای مأموریت، پنل ردیاب مأموریت در سمت راست، پنجره چت پیمایشی در پایین-چپ، پلاک‌های نام NPC شناور در فضای جهان و علامت تعجب مأموریت. رندرشده به‌صورت یک اسکرین‌شات واقع‌گرایانه مانیتور، نسبت 16:9، مناسب برای دک‌های ارائه، کی‌آرت به سبک gamescom و تیزرهای بازی شیائوهونگشو/bilibili.',
  },
  'illustrated-city-food-map': {
    title: 'نقشه غذای تصویری شهر',
    summary:
      'یک نقشه گردشگری دست‌کشیده به سبک آبرنگ تولید می‌کند که شامل غذاهای محلی شماره‌گذاری‌شده، نقاط دیدنی و یک راهنما است.',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'تصویرسازی - بازآفرینی نقاشی کودکانه مدادشمعی',
    summary:
      'یک پرامپت انتقال سبک که هر تصویر مرجع (عکس محصول، اسکرین‌شات، پرتره، ماکاپ رابط کاربری) را به یک تصویرسازی مدادشمعی دست‌کشیده بازآفرینی می‌کند که انگار توسط یک کودک ۱۰ ساله ساخته شده است. پالت اصلی را با رنگ‌های مدادشمعی شاد و روشن روی کاغذ سفید تمیز جایگزین می‌کند و عناصر کودکانه و خیال‌انگیز — قلعه‌ها، آب‌نبات‌ها، ستاره‌ها، ابرها، رنگین‌کمان‌ها — را می‌افشاند تا حال‌وهوای معصومانه و کتاب داستانی را تقویت کند. به‌عنوان یک ویرایش تصویر-به-تصویر در GPT-image-2 کار می‌کند (نیازمند آپلود یک تصویر مرجع همراه با پرامپت است)؛ به‌خوبی برای اسکرین‌شات وب‌سایت‌ها، آثار هنری کلیدی برند، عکس‌های محصول و پرتره‌ها مناسب است.',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {
    title: 'اینفوگرافیک - تجزیه‌وتحلیل کوریوگرافی رقص اوتاکو (Gokuraku Jodo، ۱۶ پنل)',
    summary:
      'یک پوستر عمودی ۲:۳ که به‌صورت یک شبکه ۴×۴ از ۱۶ پنل مربعی متصل به هم چیده شده و یک نمودار کامل تجزیه کوریوگرافی برای آهنگ مشهور رقص اوتاکوی ژاپنی 極楽浄土 (Gokuraku Jodo) را تشکیل می‌دهد. هر پنل همان دختر آیدل انیمه‌ای بانمک نیمه‌واقع‌گرایانه (موی دم‌اسبی دوقلوی صورتی، یونیفرم آیدل مدرسه‌ای با یقه ملوانی) را نشان می‌دهد که یکی از ژست‌های شاخص رقص را به‌صورت تمام‌قد، روی پس‌زمینه صورتی پاستلی، با یک نوار زیرنویس کوچک ژاپنی در پایین و یک دایره شماره‌دار در بالا-چپ اجرا می‌کند. به‌طور صریح به‌عنوان یک برگه مرجع ژست برای تولید ویدیوی هوش مصنوعی طراحی شده — هر سیلوئت واضح و بدون ابهام است، بدون خطوط حرکت یا شلوغی پس‌زمینه. تنظیم‌شده برای gpt-image-2، نسبت ۲:۳. دسته‌بندی: اینفوگرافیک.',
  },
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'اسلاید توضیحی Momotaro به سبک ترکیبی',
    summary:
      'یک پرامپت که زیبایی‌شناسی ساده و گرم تصویرسازی‌های Irasutoya را با چگالی اطلاعات بالا که مشخصه اسلایدهای دولتی ژاپن است، ترکیب می‌کند.',
  },
  'notion-team-dashboard-live-artifact': {
    title: 'داشبورد تیمی به سبک Notion (آرتیفکت زنده)',
    summary:
      'ماکاپ داشبورد تیمی بومی Notion در یک صفحه واحد — شبکه KPI، نمودار خطی ۷ روزه، فید فعالیت، و جدول وظایف پایگاه‌داده پیوندخورده. همراه بصری مهارت آرتیفکت زنده؛ برای اجراهای قابل بازآوری / مبتنی بر کانکتور آن را با این مهارت جفت کنید، یا به‌صورت مستقل به‌عنوان یک ماکاپ ثابت استفاده کنید.',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'پروفایل / آواتار - دختر انیمه به عکس سینمایی',
    summary:
      'این پرامپت یک تصویرسازی مرجع شخصیت را به یک پرتره داخلی قدیمی واقع‌گرایانه با تن‌های گرم تبدیل می‌کند، در حالی که لباس، ژست و گربه اصلی را حفظ می‌کند.',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'پروفایل / آواتار - عکاسی شبکه‌ای مد کژوال',
    summary:
      'یک پرامپت JSON ساختاریافته برای یک کلاژ ۴ عکسی از یک عکاسی مد کژوال با پارامترهای دقیق سوژه و نورپردازی.',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'پروفایل / آواتار - پرتره سینمایی مرد جنوب آسیایی با کرکس‌ها',
    summary:
      'یک پرتره سینمایی دقیق از یک مرد جوان جنوب آسیایی در یک فضای فانتزی تاریک و حزن‌آلود که توسط کرکس‌ها و کلاغ‌ها احاطه شده است.',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'پروفایل / آواتار - پرتره انیمه سایبرپانک با نوشته نئونی روی صورت',
    summary:
      'یک پرتره انیمه شیک و آغشته به نئون برای پوسترها، آثار هنری شبکه‌های اجتماعی، یا تصاویر برندینگ آینده‌نگرانه.',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'پروفایل / آواتار - دختر فانتزی شیک در باغ بنفش',
    summary:
      'این پرامپت یک پرتره فانتزی صیقلی به سبک انیمه از یک زن شیک با موی براق و مرتب، لباس بنفش-مشکی پرزرق‌وبرق، و فضای باغ جادویی پر از گل تولید می‌کند، ایده‌آل برای شخصیت',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'پروفایل / آواتار - پرتره فانتزی اثیری با موی آبی',
    summary:
      'این پرامپت یک پرتره شخصیت فانتزی نرم و درخشان به سبک انیمه تولید می‌کند، ایده‌آل برای ساخت آثار هنری کلیدی عمودی شیک یا تصویرسازی‌های شخصیت با موی روان و فضای بهاری رؤیایی.',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'پروفایل / آواتار - پرتره زن پرزرق‌وبرق در مشکی',
    summary:
      'این پرامپت یک پرتره فوتورئالیستیک به سبک لاکچری از یک زن شیک در لباس مشکی یقه‌باز تولید می‌کند، ایده‌آل برای عکاسی مد ادیتوریال یا تصاویر زیبایی.',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'پروفایل / آواتار - پرامپت‌های بافت سلفی فوق‌واقع‌گرایانه',
    summary:
      'قطعه‌های پرامپت دقیق برای تولید بافت‌های پوست واقع‌گرایانه و کادربندی اصیل سلفی با گوشی، با تمرکز بر منافذ قابل‌مشاهده پوست و نورپردازی طبیعی.',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'پروفایل / آواتار - پرتره جادوگر فانتزی اسطوخودوسی',
    summary:
      'این پرامپت یک پرتره فانتزی صیقلی به سبک انیمه از یک شاهزاده جادوگر شیک با موی بلوند براق، گل‌های بنفش، و لباس کریستالی پرزرق‌وبرق تولید می‌کند، ایده‌آل برای هنر شخصیت یا تصویرسازی جادویی',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'پروفایل / آواتار - پرتره استودیویی تک‌رنگ',
    summary:
      'یک پرامپت عکاسی تجاری سطح‌بالا برای یک پرتره تک‌رنگ با پس‌زمینه دوبخشی متمایز و نورپردازی دراماتیک استودیویی.',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'پروفایل / آواتار - بازسازی عکس قدیمی به پرتره DSLR',
    summary:
      'این پرامپت یک عکس خانوادگی قدیمی آسیب‌دیده ۴ نفره را به یک پرتره واقع‌گرایانه تمیز، رنگی‌شده و با وضوح بالا بازسازی می‌کند، برای ترمیم و بهبود عکس.',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'پروفایل / آواتار - پرتره زن شاعرانه در باغ',
    summary:
      'این پرامپت یک پرتره واقع‌گرایانه به سبک ادیتوریال از یک زن جوان کتاب‌خوان در باغی آفتابی تولید می‌کند، ایده‌آل برای عکاسی سبک زندگی، برندینگ ادبی، یا تصاویر شخصیت شیک.',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'پروفایل / آواتار - والپیپر پرتره هویتی حرفه‌ای',
    summary:
      'یک والپیپر پریمیوم با وضوح بالا تولید می‌کند که سوژه‌ای را در لباس حرفه‌ای همراه با فعالیت‌های مرتبط با شغل و تایپوگرافی نشان می‌دهد.',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'پروفایل / آواتار - سلفی هوش مصنوعی به‌طور واقع‌گرایانه ناقص',
    summary:
      'یک پرامپت خلاقانه که با GPT Image 2 استفاده می‌شود تا یک سلفی «خراب» تولید کند که شبیه یک عکس تصادفی و بی‌کیفیت با گوشی هوشمند به نظر می‌رسد.',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'پروفایل / آواتار - پرتره ماژیکی امضاشده روی Shikishi',
    summary:
      'این یک پرتره سرزنده به سبک ماژیک امضاشده روی یک تخته مربعی shikishi تولید می‌کند، مفید برای امضاهای فن‌آرت، پست‌های تصویرسازی یادبود، و تصاویر تشکر شخصی‌سازی‌شده.',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'پروفایل / آواتار - پرتره ملکه خرگوش برفی',
    summary:
      'یک پرامپت پرتره فانتزی واقع‌گرایانه برای تولید یک زن باشکوه با مضمون خرگوش در هانفوی زمستانی پرزرق‌وبرق که در فضای معبدی کوهستانی برفی ایستاده است.',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'پروفایل / آواتار - پرتره هانفوی ماسک خرگوش برفی',
    summary:
      'این پرامپت یک پرتره سینمایی زمستانی-فانتزی از زنی نقاب‌دار با هانفوی سفید خرگوش‌محور تولید می‌کند؛ ایده‌آل برای هنر شخصیت‌پردازی شیک و تصاویر نمایشی اتمسفریک با هوش مصنوعی.',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'پروفایل / آواتار - پرتره هانفوی خرگوش برفی',
    summary:
      'این پرامپت یک پرتره فانتزی فوق‌جزئیات از زیبارویی با گوش‌های خرگوشی در هانفوی گلدوزی‌شده تولید می‌کند؛ ایده‌آل برای هنر شخصیت‌پردازی شیک، طراحی لباس یا نمایش پرتره‌های سینمایی با هوش مصنوعی.',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'پروفایل / آواتار - پرتره روح خرگوش برفی',
    summary:
      'این پرامپت یک پرتره فانتزی آرام از زنی ناشناس با گوش‌های خرگوشی در زمستان تولید می‌کند؛ ایده‌آل برای هنر شخصیت‌پردازی اتمسفریک و تصویرسازی‌های سبک‌دار پروفایل.',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'پروفایل / آواتار - پرتره هانفوی دودمان سونگ',
    summary:
      'پرامپتی بهینه‌شده برای تولید پرتره‌ای دقیق و واقع‌گرایانه از زیبارویی در هانفوی سنتی دودمان سونگ در دل یک حیاط باستانی.',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'پست شبکه اجتماعی - پوستر تیزر لباس فروشگاه Pokémon انیمه‌ای',
    summary:
      'این پرامپت یک پوستر معرفی مد انیمه‌ای با رنگ‌های پاستلی ملایم تولید می‌کند که دختری با چهره محو در پیراهنی آبی داخل یک فروشگاه Pokémon را نشان می‌دهد؛ ایده‌آل برای تیزرهای رونمایی لباس و تصاویر تبلیغاتی شخصیت.',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'پست شبکه اجتماعی - صحنه سینمایی آسانسور',
    summary:
      'پرامپتی برای تولید صحنه‌ای سینمایی و حال‌وهوادار از زنی درون یک آسانسور فلزی با نورپردازی و بازتاب‌های واقع‌گرایانه.',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'پست شبکه اجتماعی - دختر اِلف گیج‌شده پشت میز پاستلی',
    summary:
      'این پرامپت یک تصویرسازی انیمه‌ای با رنگ‌های پاستلی ملایم از دختری اِلف در حال تایپ پشت کامپیوترش در یک فضای کار دنج و کاوایی تولید می‌کند؛ ایده‌آل برای پست‌های اجتماعی، والپیپر یا هنر با مضمون استریمری.',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'پست شبکه اجتماعی - عکاسی مد اِدیتوریال',
    summary:
      'پرامپتی حال‌وهوادار و متمرکز بر مد برای صحنه‌ای استودیویی مینیمال با نورپردازی ملایم و رنگ‌های گرم.',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'پست شبکه اجتماعی - کلاژ اِدیتوریال مد',
    summary:
      'پرامپتی بسیار جزئی برای کلاژ عکس ۲×۲ مخصوص عکس‌های اِدیتوریال مد، با تمرکز بر استایل یکدست، نورپردازی مشخص و ویژگی‌های چهره از یک عکس مرجع.',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'پست شبکه اجتماعی - پوستر اعلام انتقال PSG',
    summary:
      'پوستری جسورانه و حرفه‌ای برای اعلام عقد قرارداد یک بازیکن فوتبال و انتقالش به Paris Saint-Germain، مناسب شبکه‌های اجتماعی یا گرافیک‌های تبلیغاتی ورزشی.',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'پست شبکه اجتماعی - استوری‌بورد رقص دختر پرشور (۸ نما)',
    summary:
      'یک مجموعه کامل پرامپت استوری‌بورد ۸ نمایی برای تولید یک توالی رقص منسجم فریم‌به‌فریم از یک شخصیت شیک‌پوش. شامل توکن‌های سبک سراسری مشترک، یک پرامپت منفی قابل‌استفاده مجدد و هشت پرامپت برای هر نما (ژست آغازین، حرکت لگن، موج بدن، چرخش کمر هنگام افت ریتم، تاب جانبی لگن، تکان زلف، ژست قدرتمند، ژست پایانی). تنظیم‌شده برای مدل‌های رده GPT-Image-2: واژگان موجز، بدون عبارت‌پردازی حساس، و زبان قاب‌بندی و نورپردازی یکدست در همه نماها تا فریم‌ها مانند یک رقص‌آرایی پیوسته به نظر برسند.',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'پست شبکه اجتماعی - جلد مجله فرهنگ رترو روز شووا',
    summary:
      'یک صفحه ویژه‌نامه گرم سبک اِدیتوریال برای تعطیلات ژاپنی که هنر شخصیت‌های انیمه، تصاویر نوستالژیک خیابانی دوران شووا و چیدمان اطلاعاتی سبک مجله را برای تبلیغات فرهنگی فصلی ترکیب می‌کند.',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'پست شبکه اجتماعی - تولید لباس مد برای شبکه‌های اجتماعی',
    summary:
      'پرامپتی برای تولید پیشنهادهای لباس به سبک وبلاگ‌نویسان مد به‌اندازه یک هفته بر اساس پروفایل یک شخصیت، همراه با برچسب اقلام و قیمت‌ها.',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'پست شبکه اجتماعی - پرامپت کلاژ عکس‌های سفر',
    summary:
      'پرامپتی دقیق برای ساخت یک کلاژ نوستالژیک ۱۲ فریمی از عکس‌های سفر به سبک گوشی هوشمند که سفری انفرادی را به تصویر می‌کشد.',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'پست شبکه اجتماعی - طرح دستی تابلونویس قدیمی',
    summary:
      'یک طرح ماژیکی دست‌کشیده روی کاغذ با جزئیات واقع‌گرایانه مانند خطوط گرافیتی و پخش‌شدن جوهر تولید می‌کند؛ بی‌نقص برای سبک‌های حروف‌نگاری قدیمی.',
  },
  'vr-headset-exploded-view-poster': {
    title: 'پوستر نمای انفجاری هدست VR',
    summary:
      'یک دیاگرام نمای انفجاری پرتکنولوژی از یک هدست VR با برچسب‌گذاری دقیق اجزا و متن تبلیغاتی تولید می‌کند.',
  },
  '3d-animated-boy-building-lego': {
    title: 'پسربچه انیمیشن سه‌بعدی در حال ساخت Lego',
    summary:
      'یک پرامپت ویدئویی چندنمایی به سبک انیمیشن سه‌بعدی که پسربچه‌ای را در حال مونتاژ دقیق قطعات Lego در یک اتاق توصیف می‌کند و افکت‌های تایم‌لپس دارد.',
  },
  'a-decade-of-refinement-glow-up': {
    title: 'دگرگونی و درخشش یک دهه پالایش',
    summary:
      'یک پرامپت دگرگونی برای Seedance 2.0 که گذار مردی را از یک فضای معمولی سال ۲۰۱۶ به سبک زندگی لاکچری ۲۰۲۶ در دبی نشان می‌دهد و در عین حال یکپارچگی شخصیت را حفظ می‌کند.',
  },
  'ancient-guardian-dragon-rescue': {
    title: 'نجات اژدهای نگهبان باستانی',
    summary:
      'یک پرامپت سینمایی چندنمایی دقیق برای داستان دختری در روستایی بارانی که توسط اژدهایی پدیدارشونده نجات می‌یابد، با تمرکز بر جلوه‌های ویژه و صدای اتمسفریک.',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: 'ویدئوی FPV پادشاهی باستانی هند',
    summary:
      'یک پرامپت سینمایی پرشتاب به سبک پهپاد FPV که پادشاهی رازآلود هند را با معابد و جنگل‌ها به تصویر می‌کشد.',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'پرامپت انتقال انیمیشن و ردیابی دوربین',
    summary:
      'یک پرامپت فنی برای Seedance 2.0 که یک مرجع حرکتی مشخص را بر روی یک شخصیت اعمال می‌کند و در عین حال ردیابی ثابت دوربین را حفظ می‌کند.',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'رقص تغییر لباس هماهنگ با ضرب‌آهنگ',
    summary:
      'یک پرامپت برای Seedance 2.0 که رقص یک شخصیت را بر اساس فریم‌های تفکیکی هماهنگ می‌کند و همزمان یک تغییر لباس هماهنگ با ضرب‌آهنگ انجام می‌دهد.',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'توالی موشن‌گرافیک معرفی شخصیت',
    summary:
      'یک پرامپت موشن‌گرافیک پیچیده و چندمرحله‌ای برای معرفی تیمی از شخصیت‌ها با پوشش‌های رابط کاربری و گذارهای مشخص، طراحی‌شده برای مدل Seedance 2.0.',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'توالی سینمایی جشن تولد',
    summary:
      'یک پرامپت ویدیویی چندنمایی بسیار جزئی برای یک توالی جشن تولد، با تمرکز بر ثبات شخصیت و داستان‌گویی احساسی.',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'تعامل سینمایی با اژدها و پرواز',
    summary:
      'یک پرامپت سبک استوری‌بورد و جزئی برای ویدیویی که تعامل احساسی یک زن با یک اژدها و سپس یک توالی پرواز سینمایی را به تصویر می‌کشد.',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'رقص دست سینمایی زن شرق‌آسیایی',
    summary:
      'یک پرامپت ویدیویی سینمایی چندنمایی بسیار جزئی برای یک رقص دست سبک‌دار، با دستورالعمل‌های زمان‌بندی‌شده برای حرکت دوربین و کنش‌های شخصیت.',
  },
  'cinematic-emotional-face-close-up': {
    title: 'نمای نزدیک سینمایی چهره احساسی',
    summary:
      'یک پرامپت فنی بسیار جزئی برای Seedance 2.0 با تمرکز بر بافت‌های واقع‌گرایانه پوست و مجموعه‌ای از گذارهای پیچیده احساسی چهره.',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'اکتشاف سینمایی زیست‌شناس دریایی',
    summary:
      'یک پرامپت ویدیویی سینمایی جزئی برای یک صحنه زیرآب که یک زیست‌شناس دریایی را در حال کشف یک کشتی غرق‌شده باستانی در یک صخره مرجانی به تصویر می‌کشد.',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'پادکست موسیقی سینمایی و تکنیک گیتار',
    summary:
      'یک پرامپت سینمایی پیشرفته برای تولید یک ویدیوی پادکست موسیقی 4K، با تمرکز ویژه بر تکنیک گیتار، هارمونیک‌های پینچ و زیبایی‌شناسی استودیویی.',
  },
  'cinematic-route-navigation-guide': {
    title: 'راهنمای سینمایی ناوبری مسیر',
    summary:
      'یک پرامپت چندصحنه‌ای ساختارمند طراحی‌شده برای Seedance جهت ساخت یک ویدیوی ناوبری پیاده‌روی منسجم که یک شخصیت راهنمای تور تکرارشونده و گذارهای روان میان مکان‌های دنیای واقعی را به نمایش می‌گذارد.',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'توالی سینمایی مسابقه خیابانی برای Seedance 2',
    summary:
      'یک پرامپت جزئی و چندنمایی طراحی‌شده برای Seedance 2 جهت تولید یک توالی سینمایی مسابقه خیابانی در شب، با تمرکز بر تمرکز شدید راننده، کار پویای دوربین و شتاب انفجاری، ساختاریافته',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'توالی سینمایی نبرد خون‌آشام در کوچه',
    summary:
      'یک پرامپت اکشن جامع برای یک صحنه فیلم کوتاه شامل حرکات پویای دوربین و مبارزه پرسرعت در یک کوچه با نور نئون.',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'توالی سینمایی علمی‌تخیلی افق سرخ',
    summary:
      'یک توالی ویدیویی سینمایی جامع نه‌نمایی برای یک فیلم علمی‌تخیلی با عنوان «افق سرخ»، که همه‌چیز را از پرتاب موشک تا یک رویارویی هولناک با موجودات فضایی در مریخ شرح می‌دهد.',
  },
  'cyberpunk-game-trailer-script': {
    title: 'فیلم‌نامه تریلر بازی سایبرپانک',
    summary:
      'یک پرامپت گسترده تولید ویدیو برای تریلر یک بازی سایبرپانک، که طراحی شخصیت، انیمیشن‌های رابط کاربری و گذارهای محیطی از یک فضای سفید خالی به یک فاولا را شرح می‌دهد.',
  },
  'forbidden-city-cat-satire': {
    title: 'هجو گربه‌ی شهر ممنوعه',
    summary:
      'یک پرامپت کمدی تاریک پیچیده برای Seedance 2.0 که یک گربه نارنجی صاحب‌منصب و یک امپراتور کفتار را در یک فضای هجوآمیز سلسله چینگ به تصویر می‌کشد.',
  },
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'پرامپت ویدیویی فانتزی اوت کوتور هالیوودی',
    summary:
      'یک پرامپت تولید ویدیوی جزئی و چندصحنه‌ای برای Seedance 2.0، طراحی‌شده برای ساخت یک فیلم فانتزی اوت کوتور هالیوودی. این پرامپت سبک، وضوح (8K) و موتور رندر (Unreal Engin) را مشخص می‌کند',
  },
  'hunched-character-animation': {
    title: 'انیمیشن شخصیت خمیده',
    summary:
      'دستورالعملی برای Seedance 2 جهت ساخت یک انیمیشن پیاده‌روی درجا برای یک مرجع شخصیت مشخص.',
  },
  'hyperframes-html-in-canvas-iphone-device': {
    title: 'HyperFrames HTML-in-Canvas: دموی محصول سه‌بعدی iPhone + MacBook',
    summary:
      'یک دموی محصول ۱۵ ثانیه‌ای که در آن یک iPhone 15 Pro Max و MacBook Pro واقعی با فرمت GLTF روی یک صحنه تمیز شناورند و رابط کاربری واقعی اپلیکیشن به‌صورت زنده روی صفحه‌نمایش‌هایشان از طریق drawElementImage رندر می‌شود. شراره لنز شیشه‌ای مورف‌شونده + گردون ۳۶۰ درجه. ساخته‌شده بر پایه بلوک کاتالوگ vfx-iphone-device.',
  },
  'hyperframes-html-in-canvas-text-cursor': {
    title: 'HyperFrames HTML-in-Canvas: نمایان‌سازی سینمایی متن با نشانگر',
    summary:
      'یک نمایان‌سازی متن دراماتیک ۸ ثانیه‌ای با درخشش نشانگر، پرتوهای سایه رنگی و نورپردازی جهت‌دار روی یک صحنه سیاه. تایپوگرافی واقعی DOM زیر پردازش پسین شیدر زنده. ساخته‌شده بر پایه بلوک کاتالوگ vfx-text-cursor.',
  },
  'hyperframes-html-in-canvas-shatter': {
    title: 'HyperFrames HTML-in-Canvas: اوترو شکستن شیشه',
    summary:
      'یک اوترو شکستن HTML ۱۲ ثانیه‌ای — یک صفحه محصول یا کارت قیمت‌گذاری واقعی برای لحظه‌ای ثابت می‌ماند، سپس به قطعات شیشه‌ای شکست‌دهنده نور با محو شدن عمقی و پراکندگی رنگی منفجر می‌شود. ساخته‌شده بر پایه بلوک کاتالوگ vfx-shatter. به‌عنوان کارت پایانی پس از یک ترکیب طولانی‌تر مناسب است.',
  },
  'hyperframes-html-in-canvas-liquid-background': {
    title: 'HyperFrames HTML-in-Canvas: هیرو پس‌زمینه مایع',
    summary:
      'یک هیروی ۱۲ ثانیه‌ای با محتوای HTML که بالای یک سطح مایع ارگانیک شناور است — صفحه‌ی زیرتقسیم‌شده با جابجایی رأس‌ها، دینامیک موج در زمان واقعی، و DOM ضبط‌شده که شفاف و خوانا روی آن قرار می‌گیرد. ساخته‌شده بر پایه‌ی بلوک کاتالوگ vfx-liquid-background.',
  },
  'hyperframes-html-in-canvas-liquid-glass': {
    title: 'HyperFrames HTML-in-Canvas: نمایان‌سازی فرود شیشه‌ی مایع',
    summary:
      'یک نمایان‌سازی ۲۰ ثانیه‌ای ورونوی شیشه‌ی مایع از یک صفحه‌ی فرود محصول واقعی — DOM به‌صورت زنده از طریق drawElementImage ضبط می‌شود، به سلول‌های شیشه‌ای شکست‌دهنده‌ی نور می‌شکند و سپس در یک نمای هیروی تمیز ته‌نشین می‌شود. ساخته‌شده بر پایه‌ی بلوک کاتالوگ vfx-liquid-glass.',
  },
  'hyperframes-html-in-canvas-magnetic': {
    title: 'HyperFrames HTML-in-Canvas: تجسم میدان مغناطیسی',
    summary:
      'یک تجسم ۱۵ ثانیه‌ای ذرات میدان مغناطیسی که به یک نقشه‌ی حرارتی یا نمودار زنده‌ی DOM واکنش نشان می‌دهد — ذرات خطوط میدان را ردیابی می‌کنند که حول HTML ضبط‌شده خم می‌شوند، ایده‌آل برای محصولات ML/داده. ساخته‌شده بر پایه‌ی بلوک کاتالوگ vfx-magnetic.',
  },
  'hyperframes-html-in-canvas-portal-reveal': {
    title: 'HyperFrames HTML-in-Canvas: داشبورد نمایان‌سازی پورتال',
    summary:
      'یک پورتال ابعادی ۱۰ ثانیه‌ای که به روی یک داشبورد داده‌ی زنده باز می‌شود — DOM در زمان واقعی ضبط می‌شود، نشت نور حجمی، ذرات لبه‌ی پورتال. ساخته‌شده بر پایه‌ی بلوک کاتالوگ vfx-portal. طراحی‌شده برای نماهای هیروی داده به سبک کینوت.',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: شمارشگر هیجان‌انگیز پول ‎$0 → $10K‎ (9:16)',
    summary:
      'یک کلیپ هیجان‌انگیز عمودی ۶ ثانیه‌ای ‎1080×1920‎ از HyperFrames — شمارشگر ‎$0 → $10,000‎ به سبک Apple با فلش سبز، انفجار ذرات پول، آیکون دسته‌ی اسکناس، و تیتر کیکر. ساخته‌شده بر پایه‌ی بلوک کاتالوگ `apple-money-count` از HyperFrames.',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: نمایش اپلیکیشن ۱۲ ثانیه‌ای — سه گوشی شناور',
    summary:
      'یک ترکیب‌بندی نمایش اپلیکیشن ۱۲ ثانیه‌ای ‎16:9‎ — سه صفحه‌ی iPhone شناور در فضای سه‌بعدی معلق هستند، هر کدام به نوبت می‌چرخند تا قابلیتی متفاوت را نمایان کنند، برچسب‌های کال‌اوت هماهنگ با ضرب‌آهنگ، و قفل لوگو در پایان. ساخته‌شده مستقیماً بر پایه‌ی بلوک کاتالوگ `app-showcase` از HyperFrames.',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: تیزر برند ۳۰ ثانیه‌ای',
    summary:
      'یک تیزر ۳۰ ثانیه‌ای ‎16:9‎ از HyperFrames — برش‌های سریع، تایپوگرافی کینتیک هماهنگ با ضرب‌آهنگ، مقیاس واکنش‌گر به صدا روی کلمات نمایشی، گذارهای شیدر بین پنج صحنه، و کارت پایانی با شکوفایی لوگو. مدل‌سازی‌شده بر اساس کهن‌الگوی aisoc-hype از کیت دانشجویی.',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: تبلیغ محصول SaaS ۳۰ ثانیه‌ای (به سبک Linear)',
    summary:
      'یک ترکیب‌بندی ۳۰ ثانیه‌ای از HyperFrames که بر اساس فیلم‌های محصول به سبک Linear/ClickUp مدل‌سازی شده — نمایان‌سازی سه‌بعدی UI، تایپوگرافی کینتیک هماهنگ با ضرب‌آهنگ، اسکرین‌شات‌های متحرک UI، و کارت پایانی با خروج لوگو. ساخته‌شده از بلوک‌های کاتالوگ HF (ui-3d-reveal, app-showcase, logo-outro) به‌علاوه‌ی گذارهای شیدر بین صحنه‌ها.',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: خروج لوگوی سینمایی ۴ ثانیه‌ای',
    summary:
      'یک خروج لوگوی ۴ ثانیه‌ای ‎16:9‎ — مونتاژ تکه‌به‌تکه‌ی نشانه‌نوشتار با شکوفایی، جاروی درخشش روی قفل نهایی، روکش گرین نرم، و یک CTA تک‌خطی. ساخته‌شده بر پایه‌ی بلوک‌های `logo-outro`، `shimmer-sweep` و `grain-overlay` از HyperFrames.',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: نمایان‌سازی مینیمال محصول ۵ ثانیه‌ای',
    summary:
      'یک ترکیب‌بندی ۵ ثانیه‌ای از HyperFrames برای نمایان‌سازی محصول لوکس — بوم تیره، یک رنگ تأکیدی گرم، کارت عنوان با حرکت آرام به‌سمت داخل، خط کیکر کینتیک، و حرکت مهارشده. عامل از طریق puppeteer یک MP4 را از HTML+GSAP رندر می‌کند؛ نیازی به فوتیج آماده نیست.',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: پشته‌ی پوشش اجتماعی ‎9:16‎ (X · Reddit · Spotify · Instagram)',
    summary:
      'یک ترکیب‌بندی عمودی ۱۵ ثانیه‌ای ‎1080×1920‎ از HyperFrames که چهار کارت اجتماعی متحرک را روی یک لوپ دوربین چهره روی هم می‌چیند — یک پست X، یک واکنش Reddit، یک کارت در حال پخش Spotify، و یک CTA دنبال‌کردن Instagram در پایان. هر کارت یک بلوک کاتالوگ HyperFrames است؛ کوریوگرافی ارزش افزوده است.',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: ویدیوی سخنران ‎9:16‎ TikTok با زیرنویس کارائوکه',
    summary:
      'یک ویدیوی کوتاه عمودی ‎1080×1920‎ از HyperFrames — سخنران با روایت TTS روی یک لوپ دوربین چهره، با زیرنویس‌های کلمه‌به‌کلمه هماهنگ به سبک کارائوکه، نوار پایینی متحرک، و یک پوشش دنبال‌کردن tiktok در پایان. بازتاب‌دهنده‌ی کهن‌الگوی may-shorts-19 از کیت دانشجویی HyperFrames.',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: مسابقه‌ی نمودار میله‌ای متحرک (به سبک NYT)',
    summary:
      'یک اینفوگرافیک داده‌ی ۱۲ ثانیه‌ای ‎16:9‎ — نمودار میله‌ای + خطی متحرک با نمایان‌سازی پلکانی دسته‌ها، تیتر سریف به سبک NYT، منبع پانویس، و برچسب‌های مقدار کینتیک. ساخته‌شده مستقیماً بر پایه‌ی بلوک کاتالوگ `data-chart` از HyperFrames.',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: نقشه‌ی پرواز به سبک Apple (مبدأ → مقصد)',
    summary:
      'یک نقشه‌ی مسیر پرواز سینمایی ۸ ثانیه‌ای ‎16:9‎ — بزرگ‌نمایی واقع‌گرایانه‌ی زمین، هواپیمای متحرک که در طول مسیری منحنی از مبدأ به مقصد می‌خرامد، شهرهای برچسب‌دار، و شمارشگر مسافت کینتیک. ساخته‌شده مستقیماً بر پایه‌ی بلوک کاتالوگ `nyc-paris-flight` از HyperFrames، قابل بازاستفاده برای هر جفت‌شهری.',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: خط لوله‌ی وب‌سایت‌به‌ویدیو (برش بازاریابی ۱۵ ثانیه‌ای)',
    summary:
      'یک ترکیب‌بندی ۱۵ ثانیه‌ای ‎16:9‎ از HyperFrames که یک وب‌سایت زنده را در سه اندازه‌ی ویوپورت ضبط می‌کند، سپس با یک شکافت شعاعی کروماتیک بین صحنه‌ها میان آن‌ها انیمیشن می‌سازد. بازتاب‌دهنده‌ی کهن‌الگوی hyperframes-sizzle از کیت دانشجویی که در آن سایت دارایی منبع است.',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: 'اقتباس لایو-اکشن انیمه: دوئل تنفس آب در برابر تنفس رعد',
    summary:
      'یک پرامپت بسیار جزئی‌نگر ۱۵ ثانیه‌ای برای تولید یک اقتباس لایو-اکشن از یک دوئل به سبک انیمه، که \'تنفس آب\' (اژدهای آبی آب) را در برابر \'تنفس رعد\' (آذرخش طلایی) به نمایش می‌گذارد. p',
  },
  'luxury-supercar-cinematic-narrative': {
    title: 'روایت سینمایی سوپراسپرت لوکس',
    summary:
      'یک پرامپت سینمایی چندنمایی بسیار جزئی‌نگر برای Seedance 2.0 شامل یک مرد شیک‌پوش، سگ‌های دوبرمن، و یک سوپراسپرت قدیمی در یک محیط کوهستانی مه‌آلود.',
  },
  'magical-academy-storyboard-sequence': {
    title: 'توالی استوری‌بورد آکادمی جادویی',
    summary:
      'یک پرامپت جزئی‌نگر به سبک استوری‌بورد برای یک توالی سینمایی که یک دختر جادویی را در یک آکادمی به تصویر می‌کشد، و ورود، کشف قدرت، و یک دوئل جادویی را پوشش می‌دهد.',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'پرامپت ویدیوی فیلم کوتاه آرامش‌بخش با زیبایی‌شناسی روستایی مدرن',
    summary:
      'یک پرامپت جزئی‌نگر سه‌نمایی برای Seedance 2.0 جهت تولید یک فیلم کوتاه سینمایی و آرامش‌بخش به سبک زیبایی‌شناسی روستایی مدرن. این پرامپت سبک را مشخص می‌کند (تبلیغاتی سینمایی، 4K/8K، ماکروی فرین، nat',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'انیمیشن اتمسفریک فلایر کلاب شبانه',
    summary:
      'یک پرامپت انیمیشن ظریف برای Seedance 2.0 جهت جان‌بخشیدن به عناصر پس‌زمینه و نورپردازی، در حالی که سوژه قفل می‌ماند',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'زیبایی‌شناسی فیلم ووشیای رترو هنگ‌کنگ',
    summary:
      'یک پرامپت ویدیویی پیچیده و چندبخشی که زیبایی‌شناسی فیلم‌های ووشیا (هنرهای رزمی) هنگ‌کنگ دهه ۸۰ تا ۹۰ میلادی را بازآفرینی می‌کند و شامل دگردیسی یک شخصیت از گربه به انسان با نماهای سبک‌پردازی‌شده است.',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0: فیلم کوتاه عاشقانه ژاپنی سینمایی ۱۵ ثانیه‌ای',
    summary:
      'یک پرامپت بسیار دقیق و چندصحنه‌ای ۱۵ ثانیه‌ای برای Seedance 2.0 که برای تولید یک فیلم کوتاه عاشقانه ناب دبیرستانی ژاپنی، سینمایی و فوق‌واقع‌گرایانه طراحی شده است. این پرامپت چیدمان صحنه را مشخص می‌کند (خالی',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0: موزیک‌ویدیوی رپر ۸۰ ساله',
    summary:
      'یک پرامپت دقیق ۱۵ ثانیه‌ای برای Seedance 2.0 جهت تولید یک موزیک‌ویدیوی (MV) رپ خیابانی افقی ۱۶:۹ با حضور یک زن ۸۰ ساله. این پرامپت سبک را مشخص می‌کند (تن‌های سرد بنفش/آبی نئونی، exp',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: 'دستورالعمل توالی و حرکت برای ویدیوی هنرهای رزمی',
    summary:
      'یک پرامپت ویدیویی برای Seedance 2.0 که به مدل دستور می‌دهد یک توالی را بر اساس برگه شخصیت (character sheet) متحرک‌سازی کند و بر حرکات و گام‌های مشخصی تمرکز دارد.',
  },
  'soul-switching-mirror-magic-sequence': {
    title: 'توالی جادویی تعویض روح در آینه',
    summary:
      'یک پرامپت ویدیویی روایی که یک رویداد جادویی تعویض روح در کنار آینه را توصیف می‌کند، همراه با دستورات دوربین مشخص و نشانه‌های احساسی برای هر بخش.',
  },
  'toaster-rocket-jumpscare': {
    title: 'ترساندن ناگهانی با توستر موشکی',
    summary:
      'یک پرامپت برای نمایی به سبک ویدیوی خانگی واقع‌گرایانه از پیرمردی که با پرتاب نان مانند موشک از توستر، به طور ناگهانی ترسانده می‌شود.',
  },
  'traditional-dance-performance': {
    title: 'اجرای رقص سنتی',
    summary:
      'یک پرامپت ویدیویی جامع برای Seedance 2.0 جهت تولید یک رقص سنتی موزون بر اساس طراحی رقص و تصاویر مرجع هویتی.',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'ویدیو - ARPG سه پادشاهی - گوان یو یان لیانگ را می‌کشد (Seedance 2.0)',
    summary:
      'یک توالی اکشن سینمایی درون‌موتوری ۱۰ ثانیه‌ای که قالب تصویر همراه game-screenshot-three-kingdoms-guanyu-slaying-yanliang را زنده می‌کند. گوان یو (关羽) سوار بر اسب خرگوش سرخش مستقیم به خط نبرد دشمن می‌تازد، شمشیر هلالی اژدهای سبز را بالا می‌برد و با یک ضربه تمیز سردار مقابل، یان لیانگ، را از پای درمی‌آورد. تنظیم‌شده برای Seedance 2.0 — انضباط دقیق دوربین، یک ضربه قاطع، فیزیک تمیز اسب و شمشیر، نورپردازی فوتورئال و بدون هیچ خونریزی روی صفحه (ضربه با درخششی طلایی از انرژی چی القا می‌شود، نه با خون). به‌عنوان مکمل ویدیویی مستقیم قالب تصویر متناظر طراحی شده تا تصویر ثابت و کلیپ به‌صورت جفت ارائه شوند. تصویر مرجع: قالب اسکرین‌شات کشتن یان لیانگ توسط گوان یو.',
  },
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'ویدیو - ARPG سه پادشاهی - تیراندازی یوان‌من لو بو (Seedance 2.0)',
    summary:
      'یک توالی اکشن سینمایی درون‌موتوری ۱۰ ثانیه‌ای که قالب تصویر همراه game-screenshot-three-kingdoms-lyubu-yuanmen-archery را زنده می‌کند. لو بو (吕布) در مرکز یک اردوگاه نظامی غبارآلود بین دو ارتش روبه‌رو ایستاده، کمان بلند لاک‌اندود قرمزی را می‌کشد، در حالت کشش مکث می‌کند و سپس یک تیر تنها آغشته به انرژی چی با درخشش طلایی را در امتداد میدان به سوی نیزه‌ای دوردست که در زمین کاشته شده رها می‌کند. تنظیم‌شده برای Seedance 2.0 — انضباط دقیق دوربین، یک ضرب‌آهنگ قاطع، کادربندی شفاف و سازگار با HUD، فیزیک تمیز کمان/تیر، حرکت باد + گرد و غبار + پرچم، و رنگ‌بندی به سبک اسکرین‌شات درون‌بازی. به‌عنوان مکمل ویدیویی مستقیم قالب تصویر متناظر طراحی شده تا تصویر ثابت و کلیپ به‌صورت جفت ارائه شوند. تصویر مرجع: قالب اسکرین‌شات تیراندازی یوان‌من لو بو.',
  },
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'ویدیو - ARPG سه پادشاهی - فرار با نوزاد ژائو یون (Seedance 2.0)',
    summary:
      'یک توالی اکشن سینمایی درون‌موتوری ۱۲ ثانیه‌ای که قالب تصویر همراه game-screenshot-three-kingdoms-zhaoyun-cradle-escape را زنده می‌کند. ژائو یون (赵云) سوار بر اسب جنگی‌اش از میدان نبرد ویران چانگ‌بان عبور می‌کند، در حالی که وارث نوزاد، آ دو، را در گودی بازوی چپش در آغوش گرفته و نیزه‌اش را در دست راست به کار می‌برد، یک ضربه ورودی را با یک جاخالی بی‌نقص (PERFECT DODGE) دفع می‌کند و با پرش از روی یک ارابه جنگی واژگون‌شده راه را باز می‌کند. تنظیم‌شده برای Seedance 2.0 — انضباط دقیق دوربین، یک ضرب‌آهنگ پیوسته، نیزه‌بازی باورپذیر تک‌دست، فیزیک تمیز اسب، و بدون هیچ آسیب قابل‌مشاهده به نوزاد. به‌عنوان مکمل ویدیویی مستقیم قالب تصویر متناظر طراحی شده تا تصویر ثابت و کلیپ به‌صورت جفت ارائه شوند. تصویر مرجع: قالب اسکرین‌شات فرار با نوزاد ژائو یون.',
  },
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'انیمیشن دزد دریایی تمساح به سبک کلاسیک دیزنی',
    summary:
      'یک پرامپت روایی چندصحنه‌ای برای یک انیمیشن کلاسیک به سبک قدیمی دیزنی با حضور یک تمساح دزد دریایی و پرندگان دزد دریایی روی یک کشتی.',
  },
  'viral-k-pop-dance-choreography': {
    title: 'رقص‌آرایی پرطرفدار K-pop',
    summary:
      'یک پرامپت دقیق برای Seedance 2.0 جهت متحرک‌سازی شخصیتی که رقصی را بر اساس یک مرجع استوری‌بورد ۱۶ پنلی اجرا می‌کند.',
  },
  'wasteland-factory-chase': {
    title: 'تعقیب و گریز در کارخانه سرزمین بایر',
    summary:
      'یک پرامپت سینمایی برای صحنه‌ای پرسرعت در سرزمین بایر بیابانی با حضور یک کارخانه صنعتی متحرک روی پاها و تعقیب و گریز با موتورسیکلت شورشیان.',
  },
};
